var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 793.701,
    height: 1122.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-227.061 464.895h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-413.283 535.097h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-373.497 326.32h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-201.71 145.612h595.275v-841.89H-201.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-400.148 524.002h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-261.617 160.391h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-201.71 145.612h595.275v-841.89H-201.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-119.193 649.478h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-170.702 648.194h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-400.148 524.002h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-343.377 158.388h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-222.3 566.871h595.276v-841.89H-222.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-337.55 705.216h595.275v-841.89H-337.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-180.636 531.174H414.64v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-251.271 693.5h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-344.196 673.268H251.08v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-377.508 497.807h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-251.302 673.226h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-368.831 480.663h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-170.762 741.963h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-366.436 741.954H228.84v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-202.093 743.55h595.276V-98.34h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-251.271 693.5h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-390.993 667.324h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-412.848 666.904h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-187.35 666.951h595.275v-841.89H-187.35Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-218.73 667.31h595.276v-841.89H-218.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-167.9 666.546h595.276v-841.89H-167.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-417.639 741.858h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-202.093 743.55h595.276V-98.34h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-388.23 667.3h595.275v-841.89H-388.23Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-167.9 666.546h595.276v-841.89H-167.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-373.497 326.32h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-227.457 651.467h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-227.457 651.467h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-138.486 651H456.79v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-226.277 740.76h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-375.495 493.394H219.78v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-413.266 529.98H182.01v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-261.617 160.391h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-260.484 277.566h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-253.605 310.336h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-388.23 667.3h595.275v-841.89H-388.23Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-387.441 651.427h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-415.65 650.64h595.277v-841.89H-415.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-460.877 651.347h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-386.235 510.914H209.04v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-379.904 267.16h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-386.235 510.914H209.04v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-379.896 270.728H215.38v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-379.501 282.241h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-379.902 497.797h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-203.223 651.46h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-303.241 200.218h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-342.598 158.382h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-187.763 381.488h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-189.357 431.905H405.92v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-189.754 446.99h595.276V-394.9h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-188.959 418.011h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-190.148 456.515h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-138.486 651H456.79v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-187.763 381.488h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-171.816 650.627H423.46v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-180.62 528.764h595.277v-841.89H-180.62Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-361.617 463.66h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-220.762 651.01h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-304.93 707.122h595.276v-841.89H-304.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-179.03 468.424h595.275v-841.89H-179.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-180.222 515.664h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-336.263 672.889h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-260.389 672.893h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-321.55 236.154h595.275v-841.89H-321.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-294.969 605.788h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-334.228 388.252h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-336.263 672.889h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-327.112 533.125h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-328.342 458.528h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-331.874 460.874h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aA",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-330.647 603.373H264.63v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aB",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-331.874 460.874h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aC",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-338.599 385.84h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aD",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-358.477 646.62H236.8v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aE",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-330.647 603.373H264.63v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aF",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-333.065 388.22H262.21v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aG",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-327.113 530.768h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aH",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-254.026 388.217H341.25v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-267.946 530.759H327.33v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aJ",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-266.356 603.406H328.92v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aK",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-250.874 603.403h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aL",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-194.513 666.923h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aM",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-203.476 727.511H391.8v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aN",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-218.73 667.31h595.276v-841.89H-218.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aO",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-304.93 707.122h595.276v-841.89H-304.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aP",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-219.908 651.024h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aQ",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-321.55 236.154h595.275v-841.89H-321.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aR",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-261.643 385.824h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aS",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-271.946 235.057H323.33v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aT",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-265.845 292.532h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aU",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-292.545 303.322h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aV",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-262.396 388.235H332.88v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aW",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-262.01 388.251h595.276v-841.89H-262.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aX",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-404.045 729.751h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aY",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-323.932 605.772h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aZ",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-294.918 602.615h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-262.8 605.782h595.276v-841.89H-262.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-264.793 533.15h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-264.793 533.15h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-262.8 605.782h595.276v-841.89H-262.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-294.966 356.872H300.31v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-323.878 292.61h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-328.28 460.89h595.276V-381H-328.28Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-323.106 388.278H272.17v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-267.946 530.759H327.33v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-294.966 356.872H300.31v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-292.565 460.88H302.71v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-292.163 460.483h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-252.865 460.882H342.41v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-264.379 460.491h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-250.91 602.976h595.276v-841.89H-250.91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-297.77 230.992h595.276v-841.89H-297.77Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-292.165 385.88h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-275.849 284.945h595.276v-841.89h-595.276Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-275.849 284.945h595.276v-841.89h-595.276Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.026.792-.074 1.585-.074 2.378-.004 68.192-.072 136.384.032 204.577.037 24.081 1.553 48.094 4.279 72.031 2.134 18.731 5.051 37.326 9.208 55.716 3.631 16.066 8.093 31.89 14.447 47.117 4.905 11.754 10.584 23.082 19.44 32.476 2.751 2.919 5.712 5.622 9.415 7.348 1.663.18 1.034-.93.823-1.614-.683-2.209-1.555-4.355-2.341-6.53-5.967-16.517-10.189-33.489-13.377-50.739-2.259-12.223-3.828-24.541-5.031-36.902-.581-5.973-1.288-11.948-1.315-17.966-.006-1.262-.4-2.48-.37-3.745-.54-7.711-.556-15.444-1.055-23.154-.12-1.851-.096-3.701-.079-5.552.114-12.89-.92-25.78-.337-38.659.562-12.43.149-24.853.314-37.277.052-3.9-.094-7.801-.057-11.7.078-4.171-.743-8.277-.963-12.431-.142-2.699-.448-5.393-.604-8.093-.104-1.824-.451-3.509-1.527-5.035-1.689-2.396-2.773-5.1-3.8-7.825-3.303-8.817-5.062-18.009-6.597-27.252-1.415-8.52-2.424-17.095-3.366-25.68-.618-4.773-.889-9.576-1.318-14.364-.836-9.329-1.375-18.682-1.922-28.03-.223-3.813-.574-7.629-.529-11.466.046-3.824-.504-7.635-.434-11.47.021-1.124-.349-2.212-.689-3.282-1.012-2.644-1.727-5.388-2.608-8.078C7.107 17.283 4.442 9.842 1.664 2.441 1.32 1.527 1.286.31 0 0",
    clipPath: "url(#a)",
    style: {
      fill: "#bd2a26",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 302.748 619.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c4.293-3.409 8.229-7.218 12.27-10.91 4.879-4.459 9.507-9.161 13.999-14.009 10.745-11.593 20.502-23.913 28.424-37.644 6.338-10.986 11.225-22.529 14.064-34.91 1.163-5.07 1.992-10.185 2.285-15.388.086-1.51-.421-2.024-1.901-1.872-3.285.334-6.58.493-9.882.382-.725-.024-1.73.312-1.716-.995.015-1.304 1.028-.962 1.744-.967 3.638-.027 7.277-.065 10.913.016 1.24.027 1.508-.421 1.175-1.466-1.262-3.957-2.555-7.904-3.795-11.867-.244-.78-.684-1.066-1.447-.984-.131.013-.264-.001-.397.001-11.896.11-23.783-.426-35.678-.512-7.393-.053-14.791-.263-22.189-.301-.849-.005-1.64.004-1.604-1.172-2.338.809-4.709.844-7.108.29-5.988-.372-11.976.01-17.964-.062-2.04-.025-4.081-.009-6.121-.004-2.396.192-2.623.443-2.449 2.708.253 3.276.064 6.56.122 9.84.025 1.343.16 2.63 1.243 3.602.437.315.933.436 1.461.45 7.844-.048 15.689.089 23.533.075 1.126-.003 2.239.078 3.334.345 1.824-.34 3.666-.364 5.517-.36 8.717.017 17.435-.001 26.151.019.872.002 1.825-.208 2.587.444-.134.69-.647.725-1.066.844-.704.198-1.435.23-2.162.22-10.298-.134-20.583.709-30.878.396-.458.029-.991.014-1.018.655-.018.48.4.631.784.756.445.145.92.057 1.503.214-.449.592-1.041 1.012-1.369 1.634-2.617 2.219-3.078 5.137-3.073 8.388.054 31.442.032 62.883.033 94.325 0 1.845.037 3.667-.689 5.455C-1.828-1.223-1.644-.101 0 0",
    clipPath: "url(#b)",
    style: {
      fill: "#aed1e8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 551.044 713.463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.438.666-.248 1.416-.248 2.126-.012 16.671-.19 33.345.05 50.012.184 12.829.061 25.659.348 38.485.278 12.35.769 24.701 1.957 36.999 1.423 14.723 3.258 29.394 7.93 43.532 1.288 3.901 2.825 7.702 5.282 11.045 3.933 5.35 8.156 5.336 12.099-.005.553-1.361.768-2.798.871-4.244.128-1.788-.488-2.574-2.232-2.451-1.857.13-2.299-.77-2.333-2.335-.087-3.986.573-7.911.94-11.857.82-8.82 1.576-17.644 2.275-26.475.553-6.98.745-13.981 1.425-20.956.345-3.538-.35-7.112-.307-10.691.909-77.042.214-154.087.376-231.131.014-6.6.449-13.219-.328-19.816-.302-2.58.465-5.138.36-7.717-.54-13.219-.336-26.446-.398-39.67-.005-.914.065-1.873-.663-2.613-.956-.505-1.649.102-2.305.625-2.108 1.682-4.328 3.225-6.292 5.086-.643.609-1.274 1.17-1.029 2.179-.062 4.559-.002 9.117-.291 13.664-.08 1.253-.192 2.502-.218 3.76-.228 10.967-.565 21.928-1.134 32.884-.239 4.619-.168 9.248-.331 13.873-.222 6.27-.469 12.547-.58 18.827-.203 11.43-.603 22.857-.833 34.289-.094 4.689-.049 9.387-.268 14.072-.319 6.866-.092 13.751-.465 20.599-.421 7.737.021 15.465-.319 23.187-.76 17.25-.146 34.508-.351 51.76-.01.863-.025 1.719-.317 2.544-.236 1.445-.141 2.903-.142 4.357-.008 10.387-.233 20.781.058 31.16.31 11.044.101 22.089.396 33.126.276 10.308.443 20.619.799 30.922.252 7.264.254 14.523.334 21.785.011 1.059.043 2.115.252 3.157-1.246-4.561-1.595-9.264-2.148-13.935-1.333-11.231-2.044-22.517-2.706-33.797-.551-9.365-1.052-18.737-1.412-28.116-.372-9.64-.787-19.277-1.121-28.917.06-1.215.055-2.427-.139-3.631-.452-1.382-.271-2.801-.231-4.211-.054-2.428.163-4.862-.156-7.284-.448-1.43-.298-2.892-.22-4.35.163-8.732-.335-17.455-.506-26.178-.117-5.881-.098-11.767-.275-17.647-.498-16.597-.655-33.204-.3-49.797.281-13.03-.061-26.064.403-39.078.285-8.006-.08-16.013.371-23.996.411-7.277-.103-14.566.418-21.809.526-7.334-.201-14.687.676-21.994-.159-3.522.121-7.045.002-10.566-.181-1.152.096-2.345-.282-3.48-.68-.953-1.092-.145-1.443.286-.687.842-1.163 1.832-1.748 2.746-1.71 2.045-1.35 4.521-1.44 6.904-.19 11.385-.636 22.766-.502 34.155.638 1.19 1.003 2.476.901 3.808-.336 4.388.41 8.838-.764 13.174-.125.464-.025.879.047 1.341.498 3.174 1.161 6.373-.556 9.426-.27.481-.319 1.069-.054 1.532.804 1.412.636 2.94.645 4.449.049 9.238.164 18.475-.257 27.712-.095 2.09.226 4.21.283 6.324.149 5.488-.421 10.953-.439 16.434-.003.799-.168 1.575-.406 2.335-.3.959-.571 1.997-.301 2.93 1.538 5.335.1 10.763.571 16.159C1.741-19.7 1.245-14.312.54-9 .245-6.776.495-4.513.444-2.269.427-1.492.606-.666 0 0",
    clipPath: "url(#c)",
    style: {
      fill: "#8b98a7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 497.996 435.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.527-3.321 3.784-7.242 4.988-11.129 3.483-11.239 5.246-22.815 6.521-34.486.953-8.716 1.573-17.446 2.021-26.203.498-9.699.566-19.397.762-29.099.691-34.178.37-68.359.196-102.536-.067-13.08.099-26.174-.371-39.247-.317-8.79.065-17.582-.367-26.354-.439-8.922.022-17.848-.415-26.753-.373-7.599.042-15.204-.382-22.784-.385-6.871-.076-13.742-.395-20.602-.134-2.886-.332-5.758-.225-9.204 2.955 4.779 4.649 9.613 7.063 14.075 1.217-1.915 1.772-4.103 2.436-6.223 2.773-8.866 4.131-17.95 4.581-27.245.872-18.025-1.856-35.646-5.342-53.209-1.09-4.756-2.048-9.543-3.108-14.307-2.138-9.613-5.66-18.7-10.53-27.256-.345-.606-.652-1.768-1.801-.816-.141.541-.044 1.068.169 1.553 1.42 3.237 1.495 6.646 1.491 10.11-.035 29.544-.019 59.087-.029 88.631 0 .909.177 1.847-.231 2.755-.874.084-1.058-.681-1.404-1.16-1.123-1.556-2.27-3.092-3.531-4.535-.58-.664-1.115-1.555-2.267-1.202-.568.744-.505 1.624-.507 2.477-.014 7.34-.495 14.724.161 22.006.457 5.062-.084 9.983-.136 14.97-.11 10.38-.161 20.766-.013 31.146.869 60.502.163 121.006.309 181.508.014 5.87-.331 11.755-.332 17.637a31.204 31.204 0 0 0 .411 5.126c.364 2.22-.36 4.426-.398 6.676-.149 8.97-.448 17.937-1.095 26.892-.675 9.357-1.315 18.717-2.121 28.063-.613 7.112-1.384 14.209-2.085 21.312-.105 1.063-.122 2.11.102 3.156.47 2.195 1.674 2.811 3.771 1.924C-.421-5.044-.38-5.01-.513-3.188-.594-2.088-.938-.939 0 0",
    clipPath: "url(#d)",
    style: {
      fill: "#a3b8c4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 268.948 194.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.297.331.765 1.396.768 2.14.036 9.392-.018 18.785.043 28.177.026 4.019.519 8.024.397 12.055-.078 2.568-.762 5.116-.396 7.686.458 3.218.372 6.446.372 9.675.003 73.456.01 146.912-.021 220.368-.001 3.784-.358 7.598-.251 11.355.134 4.677-.313 9.326-.165 13.992.048 1.527.532 2.991.423 4.515C.66 317.075.044 324.181-.327 331.3c-.194 3.749-.57 7.475-.872 11.211-.444 5.499-.957 10.99-1.474 16.483-.392 4.183-1.128 8.356-.92 12.592.106 2.167.734 2.7 2.778 2.184 1.609-.408 2.282.184 1.902 1.823-.33 1.424-.474 2.837-.32 4.284 2.073-2.223 3.194-5.001 4.246-7.754 3.57-9.34 5.449-19.093 6.937-28.948 1.201-7.948 1.886-15.946 2.674-23.934.413-4.195.707-8.413.788-12.626.149-7.661.396-15.319.536-22.98.725-39.67.313-79.341.184-119.009-.036-11.095.085-22.208-.36-33.296-.402-10.046.042-20.095-.386-30.126-.354-8.259.02-16.525-.412-24.766-.361-6.875.048-13.75-.371-20.603-.417-6.804-.003-13.617-.422-20.401-.347-5.618-.034-11.233-.353-16.834-.33-5.81-.254-11.621-.394-17.431-.439-2.367.168-4.78-.317-7.147l-.05-4.716c-1.074-.212-1.732.535-2.363 1.149-2.925 2.853-6.263 5.197-9.398 7.79C.747-1.293-.185-1.041 0 0",
    clipPath: "url(#e)",
    style: {
      fill: "#adbbc6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 533.531 698.67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.662 8.316 1.145 16.652 2.022 24.946 1.777 16.783 4.305 33.447 8.125 49.912 3.222 13.887 7.305 27.49 12.34 40.817.195.515.972 1.218-.297 1.464 8.212 4.541 16.243 3.885 23.983-1.064 7.658-4.897 12.88-12.047 17.473-19.685 7.125-11.846 12.073-24.647 16.252-37.761 5.547-17.401 9.48-35.19 12.521-53.184.076-.454.096-.918.142-1.378.444-1.412-.474-1.767-1.546-1.907-3.012-.394-6.027-.776-9.077-.677a1.966 1.966 0 0 0-.991.355c-.391.409-.456.933-.509 1.464-1.31 12.927-4.08 25.57-7.46 38.09-2.732 10.114-6.247 19.955-10.817 29.378-3.849 7.938-8.357 15.495-14.755 21.723-1.943 1.893-4.03 3.641-6.638 4.599-2.947 1.082-4.711-.014-4.856-3.109-.243-5.16.392-10.296.534-15.447.124-4.482.491-8.951.453-13.447-.027-3.287.547-6.567.703-9.87.241-5.141.836-10.274.972-15.413.237-8.972 1.264-17.888 1.586-26.846.129-3.566.696-7.111.479-10.691-.051-.848.083-1.739-.584-2.443-.317-.215-.674-.302-1.046-.35-4.547-.236-9.095-.084-13.641-.101-7.449-.029-14.898-.017-22.347 0C1.981-.623.89-.771 0 0",
    clipPath: "url(#f)",
    style: {
      fill: "#ca3a2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 348.823 213.855)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.138-1.391-.01-2.753.313-4.118.169-.715.103-1.594-.544-2.002-.776-.489-1.134.442-1.534.861-.727.763-1.556.973-2.518.761-1.076-.237-.833-1.159-.956-1.918-.557-3.43.404-6.77.597-10.153.191-3.337.692-6.656 1.008-9.987.531-5.62 1.029-11.244 1.532-16.867.194-2.162.245-4.34.364-6.5.275-4.994.642-9.99 1.01-14.968.295-4.005.231-8.021.519-12.026.243-3.375.622-6.832.185-10.265-.141-1.101-.153-2.248.486-3.274.293-.47.264-.987.157-1.532-1.258-6.408-.718-12.851-.337-19.291.039-.659.061-1.32.061-1.98.003-59.256.145-118.513-.114-177.768-.054-12.413-.135-24.834-.235-37.251-.029-3.47 1.101-7.034.616-10.4-1.375-9.54-.234-19.081-.638-28.607.196-.777-.408-1.195-.786-1.701-1.948-2.599-4.315-4.758-6.997-6.575-.634-.428-1.372-1.062-1.834.23-.401 1.75-.524 3.52-.577 5.31-.267 8.968-.463 17.939-1.107 26.893-.279 3.882-.246 7.784-.357 11.672-.192 6.792-.801 13.581-.502 20.386.045 2.277.282 4.559-.178 6.824a7.518 7.518 0 0 0-.015 2.86c.711 3.371-.134 6.679-.411 10.01a19.06 19.06 0 0 0-.004 5.022c.376 1.084.297 2.212.278 3.329-.052 3.087-.441 6.154-.583 9.235a3.518 3.518 0 0 0-.031 1.379c.532 2.455.202 4.86-.433 7.248-.122.723-.122 1.441.051 2.157.294 10.035.439 20.07-.091 30.1-.144 2.711-.141 5.42-.099 8.125.185 11.895-.472 23.775-.468 35.668.009 32.793-.014 65.585-.001 98.377.003 8.066-.235 16.142.138 24.193.303 6.54-.001 13.082.372 19.603.423 7.396.129 14.786.292 22.17.069 3.127.289 6.313.563 9.464.229 2.627.442 5.281-1.29 7.594-.524.7-.244 1.682-.763 2.421-.955-.286-1.052-1.824-2.334-1.521 1.201 3.954 3.025 7.566 6.046 10.447 2.744 2.616 5.918 2.502 8.473-.265C-1.706 2.319-.888 1.127 0 0",
    clipPath: "url(#g)",
    style: {
      fill: "#91a0ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 268.948 194.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.028.165-8.051.022-12.059-.363-1.649-.158-2.067.494-1.924 2.02 1.277 13.635 4.844 26.606 10.707 39.007C2.365 52.596 9.468 63.555 17.577 73.926c8.113 10.376 17.219 19.826 26.67 28.957 2.841 2.744 5.893 5.27 8.848 7.896.637-.934.078-1.672-.487-2.302-1.974-2.205-2.503-4.755-2.496-7.679.068-29.955.034-59.91.052-89.865.002-3.308-.56-6.714 1.363-9.763-.779-.661-1.734-.59-2.646-.569C40.56.79 32.256-.087 23.934.193c-1.528.051-3.01-.424-4.537-.344-5.392-.166-10.796.149-16.183-.416C2.141-.681.957-.823 0 0",
    clipPath: "url(#h)",
    style: {
      fill: "#aed4eb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 158.925 865.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.512.871-2.039 2.091-2.035 3.909.061 32.397.072 64.793-.006 97.189-.006 2.62 1.04 4.543 2.6 6.371.518.607 1.154 1.11 1.026 2.026.271.273.51.59.817.812 2.032 1.468 3.689 3.127 3.213 5.945 1.138-.329.588-1.229.779-1.851.903.981 2.157 1.769 3.239 2.762.278.221.563.436.793.713 2.243 2.128 4.654 4.051 7.139 5.885 1.561.72 2.508 2.383 4.27 2.799 3.519 2.419 6.606 5.291 9.145 8.736 2.006 1.564 3.286 3.741 4.81 5.712.482.625.88 1.322 1.41 1.902.321.352.451 1.142 1.125.905.687-.241.566-.963.57-1.549.008-1.256.002-2.513.002-3.769 0-29.957-.021-59.914.034-89.871.006-2.909-.527-5.623-1.66-8.256-.213-.496-.394-.977-.351-1.521.582-.906-.191-1.504-.557-2.126a90.12 90.12 0 0 0-11.72-15.715C17.875 13.743 10.682 6.909 2.381 1.365c-.749-.5-.59-.866-.233-1.408-.042-.328-.232-.514-.55-.579C.994-.598.396-.559 0 0",
    clipPath: "url(#i)",
    style: {
      fill: "#a8cae1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 227.603 864.258)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 13.068-10.694.067-.402c-1.321-.648-1.524-1.618-.621-2.71.726-.879.578-1.855.578-2.829.006-32.395.011-64.792-.007-97.188-.001-2.696.08-5.288 2.625-7.023.287-.195.374-.684.554-1.037-.91-.503-1.515.17-2.12.614C.653-111.381-10.743-99.568-19.164-85.02c-3.084 5.329-4.765 11.165-6.268 17.067-.23.901-.155 1.843-.155 2.767-.002 29.629-.001 59.258-.001 88.887 0 .331-.017.663.008.992.064.836-.181 1.851.69 2.35.966.552 1.51-.515 2.249-.848l2.371-3.608c.355-.143.573-.436.799-.72 1.855-2.901 3.705-5.805 5.833-8.518 1.458-2.209 3.724-3.775 4.937-6.18C-6.076 4.445-2.937 2.346 0 0",
    clipPath: "url(#j)",
    style: {
      fill: "#a8c8dd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 533.531 698.67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.187.021 6.341.436 9.505.753.951.095 1.241.5 1.296 1.311 1.315-6.471 2.149-13.018 2.997-19.559a653.511 653.511 0 0 0 5.276-70.749c.119-5.882.252-11.765.253-17.648.019-66.191.013-132.384.011-198.576 0-.66-.036-1.32-.056-1.98-1.07-.323-1.132.619-1.494 1.186-3.419 10.352-7.337 20.536-10.501 30.978-.733 2.019-.797 4.112-.713 6.224.531 10.496.605 21.008.262 31.495-.553 16.865.109 33.736-.421 50.588-.36 11.444.109 22.889-.378 34.313-.358 8.402.036 16.806-.408 25.185-.326 6.153-.082 12.299-.339 18.44-.433 10.37-.529 20.747-.843 31.118-.227 7.527-.356 15.065-.764 22.584-.492 9.037-.808 18.083-1.441 27.115C1.631-18.516 1.11-9.807-.143-1.162-.2-.766-.193-.369 0 0",
    clipPath: "url(#k)",
    style: {
      fill: "#f04f41",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 457.836 211.184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.801 4.655 1.637 9.304 2.394 13.966a242.04 242.04 0 0 1 2.05 15.806C5.069 36.33 5.729 42.896 5.5 49.467c-.401 11.59-1.686 23.071-5.862 34.036-.418 1.096-.948 2.195-.83 3.434C.497 91.008 2.2 95.073 3.863 99.155c.371.911.602 1.879.898 2.822 2.426 5.281 4.203 10.808 6.104 16.286 1.88 5.415 3.629 10.876 5.434 16.317 1.244-.467.947-1.582 1.003-2.502.245-4.037-.399-8.044-.422-12.081-.044-7.929-.156-15.866-.431-23.785-.636-18.315-.106-36.627-.313-54.939-.15-13.217-.023-26.436.025-39.653.037-10.178.261-20.357.479-30.531.133-6.276.056-12.559.326-18.829.421-9.772.705-19.544.759-29.324.015-2.742-.106-2.841-2.91-2.9-1.58-.032-3.176.195-4.734-.251-3.844-.316-7.7-.187-11.553-.261-.367.161-.637.427-.851.758-.646 1.142-.681 2.401-.682 3.661-.008 19.376-.043 38.752.026 58.128.015 4.036 1.272 7.925 1.937 11.885C-.704-4.028-.246-2.032 0 0",
    clipPath: "url(#l)",
    style: {
      fill: "#89a4ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 296.4 755.828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.921-16.181 3.611-31.271-5.973-45.433 1.125 5.633.661 11.015-2.197 16.062-1.307 2.308-2.934 4.352-5.336 6.165 1.052-6.148 1.176-11.955-.051-17.78-1.779-8.451-5.638-15.778-11.78-21.809-5.45-5.353-9.141-11.559-10.313-19.172-.819-5.315-.362-10.521 1.404-15.686-2.605 1.136-6.59 4.925-9.441 8.835-6.026 8.264-8.32 17.529-7.595 27.658.471 6.579-1.256 12.558-5.283 17.826-.967 1.265-2.045 2.431-3.335 3.379-3.677 2.706-7.178 2.331-10.151-1.145-3.221-3.766-3.704-8.035-2.176-12.634.104-.314.227-.62.346-.928.115-.296.236-.59.386-.961-1.802.663-4.484 2.899-7.367 6.352-11.929 14.29-14.14 30.056-7.071 47.202.301.729.608 1.457.912 2.185.36.498.89.517 1.415.454 2.204-.262 4.423-.415 6.601-.869.507-.266.453-.747.455-1.209.061-14.636 6.931-25.244 19.258-32.663 9.272-5.58 14.786-13.751 16.636-24.411.25-1.44.047-2.901.321-4.695 1.477 1.984 2.426 3.957 3.26 5.96 2.958 7.102 3.237 14.369.995 21.71-.716 2.343-1.408 4.678-1.758 7.11a12.753 12.753 0 0 0 .787 6.62c1.604 4.044 6.211 5.258 9.648 2.561 3.026-2.374 3.922-5.632 3.896-9.17 4.751 3.911 8.068 8.962 9.959 14.947 1.002 3.172 1.533 6.416 1.402 9.765-.04 1.018-.282 2.14.599 3.005C-8.085.081-4.521.057-1.008.467-.606.514-.224.398 0 0",
    clipPath: "url(#m)",
    style: {
      fill: "#ef4623",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 450.068 940.288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.014-1.394-2.527-2.186-3.784-3.352-.49.909.085 1.862-.536 2.585-.181 9.914-.283 19.831-.566 29.744-.346 12.089-.506 24.183-.817 36.273-.215 8.395-.062 16.794-.387 25.182-.325 8.394-.052 16.795-.389 25.182-.392 9.717-.09 19.438-.396 29.149-.443 14.081-.15 28.165-.395 42.245-.486 27.971-.281 55.944-.133 83.914.051 9.516-.014 19.043.351 28.556.425 11.084.784 22.176 1.889 33.223 1.466 14.655 3.289 29.249 7.893 43.333.306.934.525 1.913 1.15 2.715 1.178.518 1.181 1.842 1.86 2.701.237.3.474.711.937.559.34-.112.452-.484.434-.823-.093-1.735.712-3.013 1.479-4.535.769-1.526.894-4.001.389-6.084-.107-.445-.258-.903-.246-1.351.138-4.794-.577-9.553-.443-14.356.296-10.565-.266-21.127-.435-31.688-.757-47.462-.209-94.924-.205-142.385.001-8.899-.187-17.836.34-26.726.583-9.843.114-19.677.315-29.512.016-.756.296-1.601-.376-2.26-.612.556-.513 1.308-.56 2.023-.494 7.482-.407 14.976-.401 22.467 0 .988.022 1.975-.301 2.929-.258 5.015-.527 10.045-.503 15.053.066 13.627-.283 27.249-.56 40.864-.614 30.231-.239 60.459-.213 90.687.01 12.22.376 24.458.831 36.674.257 6.934.263 13.88.456 20.811.14 5.037.836 10.111.162 14.829-1.573-8.449-2.302-17.345-3.076-26.241-.774-8.889-1.279-17.796-1.848-26.697-.4-6.262-.581-12.542-.932-18.809-.444-7.917-.517-15.849-1.077-23.761-.28-3.954-.289-7.933-.363-11.888-.127-6.875-.392-13.749-.585-20.618-.368-13.153-.469-26.309-.814-39.458-.562-21.432-.331-42.862-.168-64.288.067-8.855.17-17.719.241-26.578.074-9.059.381-18.113.541-27.169.102-5.747.171-11.5.271-17.249.017-.989.058-1.988-.249-2.953-.849-1.186-.978-2.537-.982-3.95-.022-7.786.21-15.579.581-23.341.197-4.117.03-8.277.577-12.391.112-.842.441-1.491.893-2.139.539-1.774.412-3.565.137-5.358-1.078-2.783-.901-5.522.294-8.226C.715 6 .591 4.47.436 2.94-.105 2.021.096.988 0 0",
    clipPath: "url(#n)",
    style: {
      fill: "#8b98a7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 240.848 708.232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.015.387.041.785-.536.858-2.61.331-3.456 2.37-4.181 4.452-1.682 4.83-2.097 9.873-2.42 14.926 1.291.981 2.788.441 4.193.547.98.074 1.971.02 2.957.022 3.07-.011 6.141-.007 9.212.002 25.213-.005 50.427-.005 75.639.001 1.955-.014 3.909.009 5.863-.018.769-.011 1.586.102 2.198-.558-.208-4.349-.665-8.66-1.747-12.898-.631-2.473-1.664-4.688-3.431-6.543-3.063-1.299-6.356-1.184-9.556-1.373-16.562-.98-33.148-1.079-49.725-.78C18.974-1.192 9.463-.971 0 0",
    clipPath: "url(#o)",
    style: {
      fill: "#666678",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 335.028 924.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-7.985.062c-.07.284.025.491.284.625 1.329.569 2.738.296 4.111.359 1.131.052 1.705.535 1.715 1.687.004.594.025 1.189.025 1.783.001 19.353.003 38.706-.001 58.058 0 4.171-.007 4.171-4.103 4.293-.595.019-1.189.036-1.775.153-.809.233-1.637.293-2.477.345-2.065.129-2.342.769-1.247 2.727 2.845.668 5.779.311 8.652.768 2.098.334 2.476.529 2.508 2.716.078 5.356.026 10.712.028 16.069.004 15.209.001 30.418.001 45.628 0 .595.011 1.191-.006 1.786-.06 2.191-.245 2.381-2.383 2.437-1.719.045-3.439-.061-5.156.058-1.594.049-3.217-.293-4.771.34-1.056 1.375-.036 1.977.988 2.488.756.377 1.66.252 2.456.551.482.127.976.128 1.467.157 1.717.135 3.437.062 5.154.065 1.503.004 2.157.748 2.213 2.179.03.727.039 1.453.039 2.18l.001 60.287c0 .264.001.529-.003.793-.039 2.963-.192 3.12-3.157 3.157-2.973.037-5.912.7-8.899.466-.706.003-1.412-.026-2.115.038-1.749.16-2.061.673-1.594 2.559 2.35 1.117 4.837.411 7.26.539 2.116.088 4.232.043 6.347.049 4.303.013 4.539.235 4.541 4.448.004 11.441.001 22.881.001 34.323 0 8.598.001 17.195-.001 25.792 0 .728-.017 1.455-.032 2.182-.033 1.538-.74 2.253-2.334 2.257-3.173.006-6.348-.113-9.521.074-.527.023-1.036.105-1.46.456-.559.854-.555 1.709-.006 2.565 1.756.92 3.641.415 5.473.488.914.026 1.83.034 2.745.007 2.393-.072 4.788-.179 6.784 1.521.727-.453.732-1.206.777-1.924.225-3.613.564-7.223.729-10.835.253-5.523.691-11.034.892-16.562.167-4.588-.341-9.175.126-13.755-.246-2.027.123-3.976.752-5.893.653-10.611.504-21.248 1.038-31.866.312-6.208-.104-12.441.109-18.653.812-23.608.353-47.223.268-70.832-.036-10.309-.059-20.632-.351-30.94-.354-12.49-.459-24.985-.852-37.47-.197-6.268.029-12.557-.611-18.823-.44-4.289-.268-4.271 4.013-4.341 1.256-.02 2.684.443 3.682-.828-.53-.922-1.461-.732-2.28-.785-1.766-.116-3.544.144-5.295-.183-1.41-1.333-.491-2.892-.423-4.368-.482-4.626.181-9.296-.565-13.91-.115-.712-.124-1.438-.598-2.037-.006-.066-.01-.131-.019-.197-.205-1.62.553-3.628-.452-4.782C3.651-.68 1.584.38 0 0",
    clipPath: "url(#p)",
    style: {
      fill: "#7e92a7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 458.928 897.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.372.514-2.372.514-2.372-2.035 0-29.095.045-58.191-.057-87.284-.012-3.644.805-7.031 1.744-10.45 1.747-6.361 4.913-12.034 8.583-17.452 4.901-7.233 10.587-13.809 16.984-19.745 4.195-3.892 8.644-7.504 13.281-10.87.2-.145.492-.164.741-.242.293-.825 1.468-.809 1.773-1.97-.906 0-1.71.021-2.512-.008-.508-.017-.959-.141-.511-.801.771-.508 1.037-1.141.488-1.976-.16-.955-.91-.785-1.542-.785-8.493-.004-16.985.001-25.477.003.344 1.282 1.45.943 2.276.969 2.771.085 5.544.028 8.316.034.528.001 1.059-.031 1.582.045.505.072 1.154.045 1.21.754.06.774-.549 1.021-1.163 1.065-2.039.144-4.056.559-6.113.488-4.819-.165-9.625.165-14.432.415-.529.029-1.055.073-1.554.274-1.692.87-1.833 2.43-1.832 4.074 0 8.864-.271 17.739.081 26.59.319 8-1.05 15.536-3.554 23.111-5.331 16.13-8 32.871-10.407 49.64-1.422 9.905-1.907 19.876-1.582 29.871.351 10.772 2.111 21.306 5.88 31.451.296.798.547 1.657 1.492 1.978 1.663-3.041 3.051-6.208 4.368-9.41.195-.473.521-.892.786-1.336.359-.614.373-1.346.678-1.981.289-.603.554-.28.832-.004l.114 2.318C-1.521 4.416-1.48 2.005 0 0",
    clipPath: "url(#q)",
    style: {
      fill: "#90afc7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 503.344 663.743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-7.168-.038c-3.408.271-3.401.272-3.682 3.642-.054.645-.185 1.285-.281 1.927-.534.58-.642 1.309-.606 2.039.188 3.778-.397 7.524-.428 11.292-.018 2.106-.194 2.273-2.254 2.306-3.108.051-6.218-.052-9.327.056-1.476-.102-2.952.011-4.429-.015-.891.136-2.062-.364-2.4 1.044.782.663 1.738.543 2.65.548 4.295.021 8.59.006 12.885.011.594 0 1.187-.001 1.779.095.966.157 1.05.871 1.052 1.632.002.755-.306 1.267-1.128 1.347-1.187.115-2.378.018-3.566.075-.781.037-1.607-.047-2.204.641 1.983.746 4.043.22 6.064.341.855.051 1.198.107 1.173 1.181-.214 9.045-.085 18.105-.561 27.134-.313 5.948.063 11.896-.361 17.815-.577 8.059.025 16.125-.393 24.167-.679 13.083-.256 26.167-.324 39.249-.105 20.343-.174 40.689.093 61.03.089 6.728-.068 13.481.386 20.192.299 4.429.012 8.851.359 13.253.212 2.701.356 5.391.327 8.096-.007.635.215 1.337-.359 1.875 1.235 4.112.844 8.375 1.015 12.562.583 14.236 1.517 28.449 2.634 42.649.366 4.649.595 9.329 1.439 13.935.942-1.028 1.293-2.289 1.264-3.629-.098-4.604-.25-9.207-.223-13.814.028-4.658.017-4.661 4.578-4.672 1.185-.003 2.383.111 3.551-.131 1.867-.386 2.225-1.443 1.102-3.105-1.729-.669-3.532-.329-5.302-.362-3.349-.062-3.482-.136-3.484-3.443-.011-15.206-.005-30.412-.004-45.618 0-5.488-.021-10.976.009-16.463.016-3.006.448-3.4 3.464-3.487 1.044-.03 2.133.135 3.059-.561.578-1.822.324-2.347-1.371-2.61a41.138 41.138 0 0 0-3.148-.361c-1.512-.117-2.015-.916-2.012-2.335.007-3.964.002-7.928.001-11.891-.003-16.452-.001-32.902-.001-49.353 0-.594-.003-1.188.001-1.783.025-3.109.026-3.109 3.155-3.379 2.299-.198 2.825-.9 2.245-2.995-1.089-.878-2.396-.613-3.623-.617-1.475-.004-2.23-.576-2.167-2.107.024-.592-.01-1.188-.01-1.782V75.335c0-.595-.013-1.189.019-1.783.115-2.177.652-2.732 2.847-3.02 1.096-.143 2.27.108 3.257-.617.573-1.721.304-2.348-1.225-2.832a4.915 4.915 0 0 0-1.366-.222c-2.802-.067-3.142.207-3.141-3.542.008-19.344.007-38.689.001-58.034C-6.14 1.203-6.152 1.202-2.085.98-1.491.947-.896.926-.354.632A.709.709 0 0 0 0 0",
    clipPath: "url(#r)",
    style: {
      fill: "#778597",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 335.07 897.634)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.541-5.963-4.075-12.191-5.258-18.557-1.697-9.14-1.694-18.351-1.487-27.566.119-5.305.845-10.586 1.417-15.871.856-7.905 2.372-15.695 3.764-23.503a226.195 226.195 0 0 1 4.11-18.459c1.721-6.467 3.849-12.825 5.841-19.218.285-.914.299-1.814.299-2.735.002-12.296.02-24.591-.026-36.887-.005-1.393.194-2.598 1.226-3.578-.532-.605-1.266-.624-1.976-.629-2.466-.018-4.932-.099-7.397.041-1.847.312-3.741.235-5.576.661-.605.271-1.171.623-1.786.864-1.84.725-2.635 2.089-2.576 4.027.021.66-.006 1.322-.006 1.983 0 57.261 0 114.521.003 171.781 0 1.123-.106 2.258.149 3.362.248 1.074.731 1.896 2.065 1.288l1.043-1.177c1.298-4.589 3.429-8.849 5.225-13.242C-.599 1.735-.027.967 0 0",
    clipPath: "url(#s)",
    style: {
      fill: "#8ba7bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 491.775 640.884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.864 1.024-2.307.46-3.276 1.196 1.019.723 1.995 1.444 2.614 2.614 2.009 3.792 4.912 6.862 8.064 9.717.332.301.909.522.824 1.033-.109.649-.8.593-1.284.692-5.39 1.093-4.635 1.056-4.781 6.08-.204 7.009.528 13.866 3.013 20.463 2.353 6.246 5.98 11.611 11.17 15.867.511.419.974.899 1.491 1.305 2.043 1.601 2.88 3.633 2.638 6.248-.177 1.9-.11 3.835-.012 5.748.083 1.634-.337 2.71-2.157 2.868-.59.051-1.173.273-1.59.736-.283.317-.138.593.198.794 2.265.539 4.542.326 6.819.136 2.907-.599 5.847-.143 8.769-.276 2.107-.063 4.239.383 6.317-.297 1.47-1.636 2.015-6.648.907-8.408-.608-.966-1.587-1.353-2.625-1.631-1.66-.445-3.373-.656-5.03-1.112-2.838-.782-3.726-1.891-3.729-4.765-.015-13.674-.369-27.362.165-41.015.226-5.775.574-11.559.578-17.347.002-1.667 1.391-1.492 2.184-2.122-.046-1.217-1.049-.998-1.733-1.04-1.979-.119-3.973-.158-5.948-.018-7.114.504-14.254.745-21.309 1.92C1.496-.484.695-.442 0 0",
    clipPath: "url(#t)",
    style: {
      fill: "#8d9bab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 227.682 989.284)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.341.667-1.163.396-1.621.833-.319 1.1.375 1.909.856 2.74 2.276 3.925 5.044 7.438 8.73 10.156.264.196.533.389.753.64.096.11.141.225.072.498-1.221.684-2.723.583-4.096.959-1.522.416-2.43 1.223-2.617 2.822-.076.656-.272 1.304-.236 1.965.413 7.658.772 15.31 3.825 22.541 3.167 7.504 8.172 13.389 15.107 17.601 2.094 1.271 3.106 2.851 2.914 5.348-.162 2.103-.098 4.231.004 6.345.046.961.015 2.053 1.291 2.394 2.383-.005 4.764.063 7.141-.021 2.725-.095 3.337-.783 3.386-3.499.015-.858.012-1.718.003-2.577-.033-3.016-.692-3.905-3.604-4.889-1.251-.422-2.527-.758-3.762-1.241-2.387-.932-3.416-2.544-3.388-5.179.097-9.582.039-19.165.038-28.749 0-3.239-.297-6.51.065-9.708.649-5.72.812-11.437.715-17.175-.022-1.353-.08-2.724-1.551-2.963 2.238.085 4.807.734 7.305-.362-.359-1.339-1.51-1.03-2.392-1.04-6.183-.063-12.347.348-18.499.935-2.813.269-5.629.531-8.424.973C1.31-.542.552-.588 0 0",
    clipPath: "url(#u)",
    style: {
      fill: "#8d9bab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 488.58 989.272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.822.086-2.859.087-2.806 2.964.073 3.96-.103 7.919.104 11.885.078 1.492-.971 2.869-.96 4.541.094 13.817.053 27.636.053 41.455 0 3.017 1.044 4.357 4.053 5.078 1.85.443 3.723.798 5.583 1.202 1.556.338 2.415 1.169 2.292 2.906-.148 2.087.317 4.245-.826 6.198.597.647 1.404.633 2.174.622 2.266-.035 4.541.213 6.797-.189 2.005-.596 2.84-2.006 2.742-4.024-.11-2.268.461-4.627-.868-6.739-1.171-.491-2.342-.053-3.514.004-2.189.108-3.117-.648-3.124-2.802a8207.336 8207.336 0 0 1-.004-41.811c.005-2.188.781-2.791 3.005-2.462 2.105.312 4.079 1.102 6.056 1.84 1.535.573 2.707.407 3.439-1.19-.083-.582.063-1.107.394-1.585.882-3.664 1.132-7.381.967-11.136-.065-1.461-.156-2.907-1.373-3.968-.841-.734-2.533.052-2.862-1.6C15.104.48 8.909-.497 2.631-.564 1.727-.574.761-.721 0 0",
    clipPath: "url(#v)",
    style: {
      fill: "#93aabc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 269.458 991.399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.466 1.248 3.204.483 4.651.268C7.798-.2 10.967-.15 14.097-.296c15.299-.712 30.62-.599 45.933-.451 6.316.06 12.632.434 18.941.776 2.929.158 5.823.811 8.776.762 1.231-2.208 1.856-4.627 2.269-7.083.586-3.478-.266-4.624-3.736-5.424l-11.657-1.09c-.879-.684-1.945-.849-2.983-.85-6.036-.007-12.054-.786-18.098-.429a773.03 773.03 0 0 0-21.265-.007c-6.965-.134-13.902.457-20.847.822-.728.039-1.439.188-1.971.764l-8.2.906c-2.941.708-3.333 1.19-3.216 4.272C-1.86-4.746-1.167-2.306 0 0",
    clipPath: "url(#w)",
    style: {
      fill: "#4a445a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 335.028 924.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.757-3.199-.377-6.452-.312-9.669.039-1.961-.804-3.224-2.261-4.063-6.409-3.694-11.341-8.793-14.685-15.361-2.256-4.432-3.366-9.237-4.191-14.135-.529-3.137-.053-6.318-.719-9.438-.275-1.289.117-2.61.323-3.916.14-.877.536-1.277 1.343-1.446 1.67-.349 3.334-.724 5-1.086.362-.079.886.115 1.018-.382.143-.546-.352-.817-.719-1.064-4.963-3.334-8.362-7.959-10.976-13.237-1.599.107-3.092.628-4.577 1.182-1.781.663-2.372 1.845-1.938 3.735.542 2.358 1.726 4.418 2.714 6.573.466 1.02.994 2.013 1.433 3.044 1.288 3.018 1.3 3.05-1.235 5.194-1.21 1.024-1.65 2.207-1.612 3.806.387 16.241 1.286 32.436 3.919 48.493.076.457.1.919.149 1.379.427.989 1.341 1.006 2.188 1.015 6.284.061 12.57.056 18.855.006C-5.165.621-4.115.011-2.966.211-1.98.104-.963.441 0 0",
    clipPath: "url(#x)",
    style: {
      fill: "#7a8a9b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 521.324 889.766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.872.816 3.831.257 5.748.333.65.026.521-.838.953-1.123 1.322-7.73 2.027-15.535 2.747-23.334.425-4.592.7-9.206.825-13.815.119-4.357.654-8.698.447-13.064-.034-.723.145-1.52-.38-2.101-2.076-2.294-1.218-4.63-.149-6.964 1.046-2.282 2.137-4.541 3.206-6.811.057-.119.098-.245.15-.367 1.614-3.802.936-5.294-2.965-6.426-.884-.257-1.801-.396-2.7-.601-.701-.16-1.482-.228-1.595-1.185-.782-.186-1.435-.055-1.82.74.11 4.555.092 9.111.075 13.667-.009 2.601-.414 2.936-2.954 2.334a70.745 70.745 0 0 0-6.823-1.248c-2.985-.403-4.473.806-4.483 3.759-.049 14.211-.053 28.422.003 42.632.012 3.154 1.491 4.53 4.671 4.642 1.191.042 2.378-.03 3.565-.139C-.416-9.169.432-8.822.472-7.644.559-5.085.968-2.496 0 0",
    clipPath: "url(#y)",
    style: {
      fill: "#a4bac7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 550.464 889.206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.538-.231 1.077-.666 1.612-.661 2.537.026 3.032-1.345 2.808-3.548-.173-1.699-.268-3.469.013-5.139.632-3.766-1.366-6.116-3.996-8.196-7.14-5.644-11.1-13.162-13.141-21.887-1.335-5.712-1.155-11.493-1.203-17.28-.01-1.185.484-1.678 1.496-1.902 1.346-.298 2.693-.591 4.042-.871.43-.09 1.001.081 1.15-.524.127-.52-.244-.879-.616-1.153-2.457-1.815-4.462-4.068-6.402-6.407-1.19-1.435-2.096-3.036-2.975-4.644-.618-1.131-1.379-1.71-2.653-1.603-5.083 1.002-5.968 2.664-3.859 7.409 1.125 2.533 2.357 5.017 3.52 7.533.76 1.645.922 3.058-1.061 4.122-1.619.868-2.202 2.329-2.144 4.303.477 16.042 1.294 32.052 3.891 47.92.075.455.091.92.135 1.38-.058 1.878 1.089 2.375 2.66 2.174C-11.886.41-7.029.794-2.184.657-1.406.635-.589.681 0 0",
    clipPath: "url(#z)",
    style: {
      fill: "#778595",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 249.8 889.269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-9.144-.009-6.323.027a.696.696 0 0 0-.084.656c.476 1.038.737 2.124.675 3.27-.21 3.873.578 7.806-.697 11.616-.072.212.101.363.224.516 1.913.699 3.907.293 5.862.41 3.278.197 6.578-.296 9.839.299.724.326.7.975.706 1.619.007.695-.05 1.403.306 2.047l.225.218.398-.4c.834-1.314.83-2.637.045-3.968.646-.818 1.568-.259 2.336-.471 1.486-.536 2.129-1.625 2.175-3.174.111-3.676-.215-7.363.329-11.028.089-.602-.119-1.17-.528-1.643-.948.012-1.241-.389-1.081-1.36 1.348-8.181 2.167-16.416 2.75-24.688.579-8.217 1.118-16.428 1.142-24.668.003-1.1-.086-2.071-1.008-2.844-1.038-.871-.379-2.123-.588-3.186-1.035.965-1.983 1.254-3.482.566a24.336 24.336 0 0 0-6.399-1.945c-2.147-.335-3.234.502-3.234 2.644-.003 14.264-.003 28.528 0 42.792 0 2.038 1.067 3.292 3.098 3.082 1.336-.139 2.772-.044 4.046-.685 1.467.636 2 1.76 1.831 3.324-.085.783-.014 1.584-.015 2.376C3.4-.993 3.4-.993 0 0",
    clipPath: "url(#A)",
    style: {
      fill: "#a6bcc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 291.64 889.748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.622.017-9.25-.12-13.864.082-9.032.396-18.076.083-27.096.459-5.408.226-10.806.153-16.207.279-.994.024-1.718.107-2.067 1.305-1.139 3.915-2.38 7.801-3.645 11.678-.413 1.267.265 1.325 1.173 1.324 3.631-.007 7.263-.015 10.894.01.696.004 1.472-.248 2.051.406 1.015.42 2.076.177 3.115.19 5.442.071 10.887-.112 16.329.131 8.858-.243 17.716-.033 26.573-.11 1.115-.009 2.255.141 3.321-.349.788-.619.29-1.144-.146-1.646-.393-.451-.886-.895-.885-1.504.003-3.66-.726-7.357.489-10.961C.184.854.373.422 0 0",
    clipPath: "url(#B)",
    style: {
      fill: "#afd4eb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 223.867 888.728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.541-.042 1.079-.095 1.496-.505.903-2.127 1.698-4.29 2.264-6.536.475-1.886-.091-3.203-1.945-3.968-4.203-1.733-8.663-2.321-13.11-2.835-12.079-1.396-24.11-1.094-36.035 1.463-1.283.276-2.56.654-3.78 1.134-2.78 1.092-3.226 1.943-2.454 4.862.573 2.167 1.329 4.284 2.361 6.288 4.767-.458 9.527-1.084 14.306-1.332 5.687-.294 11.379-1.178 17.09-.274.476.573 1.15.599 1.805.62 5.333.166 10.638.651 15.918 1.409C-1.356.432-.638.477 0 0",
    clipPath: "url(#C)",
    style: {
      fill: "#666778",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 556.852 989.144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c6.135-.08 12.209.545 18.26 1.503 1.024.161 2.103.375 3.062-.314a29.075 29.075 0 0 0 2.223-6.126c.64-2.637.206-3.609-2.343-4.593-3.972-1.534-8.172-2.109-12.361-2.598-12.213-1.429-24.37-1.105-36.43 1.455-1.555.33-3.04.844-4.504 1.467-1.444.614-1.976 1.627-1.794 3.129.332 2.729 1.529 5.167 2.555 7.663 2.05.391 4.02-.289 6.013-.515C-17.27.16-9.208-.429-1.104-.317-.734-.312-.368-.11 0 0",
    clipPath: "url(#D)",
    style: {
      fill: "#666778",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 269.458 991.399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.358-.009-14.717-.016-22.076-.029-.846-.001-1.717.119-2.487-.387-.998.744-2.027.002-3.039.021-3.75.073-7.502-.028-11.254-.064.726 5.403-.102 10.883.8 16.277.658.764 1.566.609 2.401.605 10.685-.048 21.371.159 32.056.09.972-.006 2.003.137 2.81-.641-.943-1.464-.745-3.109-.808-4.73-.123-3.202.311-6.41-.288-9.61C-2.192-.114-.736.605.004.392.136.304.18.216.135.13.09.043.045 0 0 0",
    clipPath: "url(#E)",
    style: {
      fill: "#9ab1c4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 517.64 889.732)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.237 4.033-.803 8.398-1.121 12.604-.101 1.331 1.715 1.332 1.935 2.5 1.052.729 2.269.829 3.492.917 3.839-.592 7.702-.149 11.551-.281 1.372-.047 2.746.053 4.119-.029 4.254-.074 8.507.004 12.76-.042.89-.009 1.859.202 2.587-.582.917-1.024 1.278-2.193 1.241-3.595-.081-3.078.01-6.161-.045-9.24-.019-.988.117-2.148-1.168-2.617-2.913-.314-5.825-.299-8.738-.012l-7.162-.027c-5.723.163-11.46-.172-17.17.394C.965.12.354-.393.067-1.554L0 0",
    clipPath: "url(#F)",
    style: {
      fill: "#a8cae1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 223.867 888.728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.658-.248.852-.762.845-1.415-.088-7.768 1.491-15.463 1.134-23.227-.167-3.616-.457-7.199.036-10.81.196-1.443-.01-2.882-.567-4.272-.427-1.068-.345-2.253-.143-3.332 1.489-7.942 1.087-15.966 1.101-23.968.012-6.539.175-13.075.24-19.607.045-4.522-.087-9.084-.231-13.626-.008-.249-.067-.628-.23-.721-1.542-.872-1.016-1.551.152-2.223.159-.092.379-.284.376-.426-.062-2.984.713-6.011-.425-8.936-.079-.204-.435-.308-.306-.625 2.072-5.063.588-10.397 1.172-15.576.109-.966-.692-1.504-1.544-1.837-.365.747-.274 1.55-.285 2.34-.184 14.008-.219 28.02-.596 42.023C.417-74.673.612-63.107.33-51.547-.088-34.366.056-17.183 0 0",
    clipPath: "url(#G)",
    style: {
      fill: "#8c98a7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 497.996 435.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.554.008 7.108-.013 10.662.039 1.105.016 1.697-.199 1.671-1.5-.101-4.927.639-9.834.381-14.767l-5.611.095c-1.306.22-2.621.069-3.931.096-1.986.041-2.416.379-2.533 2.391-.13 2.231-.038 4.466-.046 6.7-.008 1.968.121 3.948-.69 5.825C-.253-.759-.276-.353 0 0",
    clipPath: "url(#H)",
    style: {
      fill: "#93aabc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 303.276 868.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.383-2.171 1.236-4.599 1.203-7.016-.028-1.967-.009-3.936-.005-5.904.006-2.824.095-2.879 2.832-2.937 1.023-.022 2.096.318 3.073-.276-3.171-.215-6.329.039-9.486.275-.517 4.331-.429 8.683-.358 13.028.023 1.37-1.086 1.881-1.618 2.817L0 0",
    clipPath: "url(#I)",
    style: {
      fill: "#8dacc4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 303.276 868.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a107.511 107.511 0 0 0-19.348-.003l.056 1.525c6.419.192 12.834.623 19.262.418C.58 1.303.646.657 0 0",
    clipPath: "url(#J)",
    style: {
      fill: "#68697b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 184.648 868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.419 4.474.844 8.979.185 13.48-.087.591-.372 1.15.221 1.624 1.336-2.769 2.792-5.486 3.979-8.317C6.263 2.306 4.978.411 0 0",
    clipPath: "url(#K)",
    style: {
      fill: "#a6bcc9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 301.703 987.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.007-.499.167-1.174-.453-1.31-.733-.159-.596.635-.805 1.044-.369.721-.304 1.486-.253 2.251C-.678 1.573-.714.501 0 0",
    clipPath: "url(#L)",
    style: {
      fill: "#a8c8dd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 500.66 657.858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.151 2.381-.425 4.794.317 7.147C.224 4.765.708 2.355 0 0",
    clipPath: "url(#M)",
    style: {
      fill: "#a8c8dd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 551.02 706.64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 39.292.001c.711-.788.871-1.787.918-2.768.24-5.006.6-10.004.888-15.007.297-5.134.637-10.265 1.043-15.392.156-1.976.28-3.948-.037-5.916-.705-1.434-1.546-.497-2.237-.045-1.657 1.087-3.229 2.287-5.103 3.033-1.205.48-2.245.425-3.409-.144-6.377-3.119-10.741-8.275-14.301-14.19C12.2-58.492 9.176-67.303 6.807-76.363c-3.409-12.679-5.457-25.603-7.03-38.614-.097-.804.148-1.779-.91-2.197-.029 4.426-.077 8.854-.084 13.28-.015 10.115.245 20.238-.093 30.341-.286 8.584-.493 17.171-.203 25.737.269 7.923.015 15.846.353 23.755.279 6.515.599 13.027.759 19.546C-.365-3.007-.139-1.505 0 0",
    clipPath: "url(#N)",
    style: {
      fill: "#f0543b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 348.823 213.855)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.632 4.633 1.195 9.276 1.911 13.896 1.433 9.254 2.973 18.489 5.69 27.479 1.221.881 2.363 2.102 4.061.945-.575-4.568-.844-9.165-1.354-13.741-.671-6.028-1.457-12.039-2.183-18.059a2149.695 2149.695 0 0 1-2.634-22.79c-.093-.842-.353-1.695.093-2.518.203-.947-.399-1.643-.799-2.377-2.388-4.382-3.397-9.141-3.871-14.044-.138-1.43.21-2.631 1.774-3.146.406-.134.944-.228.878-.879-1.109-2.831-1.115-5.848-1.177-8.783-.073-3.439-.428-6.842-.651-10.261-.632-9.683-.862-19.377-.799-29.08.042-6.471.055-12.943-.022-19.413-.021-1.854.455-3.663.288-5.515a1.678 1.678 0 0 0-.647-.428c-1.765-.395-3.552-.212-5.33-.179-1.423.028-2.182.774-2.259 2.213-.046.859-.044 1.718-.044 2.576-.002 21.676-.007 43.352.009 65.027.001 2.102-.389 4.221.187 6.307.911 2.986 2.273 5.758 4.016 8.34.521.774 1.002 1.511 1.08 2.496C-1.208-14.621-.599-7.311 0 0",
    clipPath: "url(#O)",
    style: {
      fill: "#92b2cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 347.313 370.088)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.006-15.377.245-30.771.434-46.156C.546-55.277.49-64.402.42-73.524c-.012-1.568.445-2.124 2.009-2.027 1.711.107 3.436.012 5.154.006.171-.101.345-.112.549-.109.916.014 2.088.091 2.314-.959.221-1.028-1.06-1.128-1.703-1.616a2.778 2.778 0 0 0-.669-.172c-2.362-.087-4.723-.264-7.078.096a1.291 1.291 0 0 0-.575.424c.645 1.645-.007 2.352-1.68 2.349-1.852-.004-3.715.136-5.554-.02-1.746-.148-2.571.705-2.583 2.201-.034 4.089-.125 8.174.097 12.272.147 2.728.337 5.573-.618 8.27.671 8.637 1.873 17.21 3.267 25.751C-5.245-18.449-3.557-9.892-.698-1.617-.507-1.064-.234-.539 0 0",
    clipPath: "url(#P)",
    style: {
      fill: "#839baf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 338.14 413.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.004.131.005.261.004.392l24.613.003c.976.055 1.219-.475 1.203-1.357-.039-2.112.013-4.226-.019-6.34-.028-1.752-.937-2.464-2.707-2.044-1.576.374-3.161.242-4.726.161-1.863-.095-2.875-1.447-2.876-3.578-.01-14.463.058-28.926-.067-43.388-.021-2.385 1.939-3.28 3.632-2.935 2.697.55 5.401 1.065 8.095 1.626 2.035.425 2.619-.015 2.623-2.095.009-4.028.027-8.057-.013-12.085-.01-.974-.231-1.946-.354-2.919-6.564-1.011-13.149-1.783-19.807-1.702l-8.434-.001c2.657.742 1.991 2.814 2.008 4.537.024 2.576.227 5.174-.029 7.724-1.565 15.523-.32 31.086-.796 46.62-.149 4.829 1.818 4.953 4.969 6.37.23.103.512.081.754.163 5.124 1.744 6.13 3.481 4.988 9.093C12.74-.181 11.134-.112 9.895-.047c-2.372.126-4.754.027-7.132.022L0 0",
    clipPath: "url(#Q)",
    style: {
      fill: "#8ba3b4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 517.64 889.732)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-37.267-.053c-.736 1.598-.659 3.204-.051 4.817a2.19 2.19 0 0 0 .576-1.632c-.122-1.836.93-2.156 2.468-2.14 4.201.046 8.404.07 12.604-.01 1.749-.033 2.979.272 2.918 2.364-.012.397.251.736.517 1.037l9.51.007c6.001-.143 11.994-.589 18.004-.473 1.564.03 3.118-.451 4.715-.379 1.285.058 1.409-.917 1.487-1.892.092-1.164-.628-1.25-1.513-1.248-3.571.011-7.14.006-10.709-.026-.697-.007-1.47.25-2.07-.367L0 0",
    clipPath: "url(#R)",
    style: {
      fill: "#7c8d9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 516.589 868.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.487 1.976c.576.656 1.35.411 2.048.412 4.686.008 9.389.223 14.056-.082 5.473-.36 10.938-.202 16.404-.35.847-.023 1.689-.24 2.534-.359.865-.122.731-.787.746-1.366.014-.626-.257-1-.928-1-.463 0-.925-.012-1.387-.012-10.166.002-20.333.004-30.499.01C1.583-.771.604-.981 0 0",
    clipPath: "url(#S)",
    style: {
      fill: "#fafcfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 554.2 867.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.712-.001-5.425.025-8.137-.015-.958-.013-1.46.195-1.45 1.306.011 1.132.676 1.092 1.435 1.071 5.486-.148 10.971-.298 16.458-.44.701-.019 1.332-.032 1.267-1.035C9.506-.146 8.772.01 8.138.007 5.426-.006 2.713.001 0 0",
    clipPath: "url(#T)",
    style: {
      fill: "#67697b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 614.503 868.463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.353 2.657-4.22 5.646-5.952 8.725-.507 1.431.164 2.964-.381 4.392l.002 10.714c1.09-.117.971-1.055 1.219-1.809-.257 1.215-.282 2.396-.282 3.582.003 69.788-.001 139.576.017 209.364.001 2.778-.116 5.559.028 8.331.071 1.351-.671.292-.982.456-.188 5.677.365 11.335.482 17.005.125 6.047.48 12.099.755 18.148.341 7.488.852 14.969 1.19 22.461.331 7.346.892 14.689 1.585 22.011.745 7.898 1.457 15.809 2.782 23.639.233 1.381.878 2.692 1.347 4.077.828-.523.678-1.284.555-1.859-.849-3.979-.181-7.993-.322-11.987-.279-7.943-.049-15.913-.537-23.84-.343-5.55.055-11.093-.345-16.613-.711-9.835.062-19.682-.406-29.503-.684-14.332-.113-28.662-.345-42.99.003-15.075-.164-30.154.06-45.225.147-9.909.092-19.823.389-29.723.742-24.715.571-49.433.596-74.152.025-23.606.007-47.214.004-70.82 0-.926.062-1.858-.09-2.773C1.239.825 1.101-.013 0 0",
    clipPath: "url(#U)",
    style: {
      fill: "#7a8898",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 514.98 681.22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.823.57.646 1.698 1.447 2.568v-226.486c-1.005 1.177-.37 2.903-1.447 3.994-.766 6.049-.004 12.146-.469 18.185-.552 7.196.105 14.399-.399 21.565-.559 7.923.071 15.848-.376 23.748-.694 12.28.109 24.57-.415 36.833-.608 14.199-.436 28.398-.209 42.585.151 9.436-.133 18.886.369 28.304.3 5.613-.084 11.227.373 16.805.352 4.29.216 8.565.334 12.846.738 1.264-.009 2.674.389 3.971l.009 7.54c.785 1.261.189 2.656.385 3.973L0 0",
    clipPath: "url(#V)",
    style: {
      fill: "#798797",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 506.54 356.213)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.927.425.81 1.261.81 2.051 0 44.436.162 88.873-.121 133.308-.066 10.426.039 20.866-.296 31.293-.594 18.529-.291 37.061-.366 55.592-.003.694-.26 1.471.383 2.06.532-.843.398-1.786.398-2.704.004-15.28-.249-30.565.101-45.836.2-8.718-.096-17.445.391-26.14.318-5.683-.114-11.37.371-17.015.494-5.748-.09-11.503.401-17.213.483-5.617-.082-11.237.395-16.816.428-5.021-.066-10.051.402-15.03.441-4.693.057-9.373.346-14.044.507-8.163.583-16.335.841-24.504.238-7.573.528-15.146.783-22.72.265-7.903.739-15.801.737-23.713 0-1.507 1.109-3.101-.365-4.488C3.276-4.12 1.487-2.193 0 0",
    clipPath: "url(#W)",
    style: {
      fill: "#8492a2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 514.98 681.22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.42-1.377.991-2.77-.386-3.973C-.224-2.652-.795-1.26 0 0",
    clipPath: "url(#X)",
    style: {
      fill: "#7a8898",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 506.527 360.971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.184-1.354.775-2.749-.389-3.971C-.225-2.651-.798-1.258 0 0",
    clipPath: "url(#Y)",
    style: {
      fill: "#7a8898",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 506.001 376.322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.832-1.403.203-2.933.381-4.392l-.404.774z",
    clipPath: "url(#Z)",
    style: {
      fill: "#8492a2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 506.536 663.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-15.469.059c.473 1.255 1.602.949 2.509.961 4.294.057 8.59.021 12.885.027.66.001 1.326-.038 1.978.08.636.115 1.465.167 1.416 1.044-.042.77-.771.992-1.449 1.11-.72.125-1.449.093-2.176.104-9.446.136-18.878-.633-28.325-.446-.649.013-1.326-.197-1.906.278-.255.513-.838.279-1.273.561 3.312 2.58 6.644 5.087 9.877 7.716 5.478 4.455 10.394 9.493 15.089 14.758 4.128 4.629 7.7 9.653 10.894 14.958.164.272.235.602.35.904 1.717 1.946 2.735 4.326 3.841 6.604 3.226 6.643 5.776 13.559 7.436 20.767 1.089 4.727 2.006 9.494 3.014 14.24.064.301.255.576.386.863.358-2.632-.577-5.119-.937-7.66-.674-4.745-1.519-9.433-1.487-14.279.116-17.378.044-34.758.046-52.137 0-1.908-.118-3.824.398-5.695l-.013-.043c-.694-.503-.571-1.183-.504-1.915.074-.8.6-1.596.105-2.423-.705-.461-1.499-.406-2.289-.407C9.598.023 4.799.011 0 0",
    clipPath: "url(#aa)",
    style: {
      fill: "#8dacc4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 270.964 868.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.18 6.505-.579 12.957-1.107 19.422-.182 2.221-.21 4.454-.337 6.675-.26 4.58-.525 9.158-.888 13.732l.77.022c.53.462 1.174.617 1.843.59 3.437-.136 6.848.391 10.274.413 8.245.053 16.464.604 24.686 1.133 1.366.088 2.762.348 4.115-.151l.78-.005c1.35-3.021 1.204-6.307 1.54-9.48.684-6.461 1.116-12.95 1.606-19.431.189-2.491.229-5.003.315-7.489.132-3.819.464-7.627.551-11.45.202-8.695.677-17.381.869-26.08.078-3.546.057-7.115.297-10.662.432-6.393.058-12.813.474-19.185.405-6.211-.108-12.42.358-18.596.617-8.187-.092-16.383.401-24.546.647-10.7-.053-21.4.375-32.085.682-17.042.009-34.09.458-51.124.141-5.339.192-10.68.288-16.018.133-7.435-.128-14.866-.421-22.295-.264 5.131-.497 10.263-.796 15.391-.522 8.957-1.082 17.912-1.638 26.867-.015.25-.153.492-.234.738-1.17 2.182-.828 4.61-1.032 6.926-1.625 18.415-3.524 36.788-7.756 54.831-1.158 4.961-2.535 9.853-4.569 14.541-.607 1.397-1.162 2.842-2.112 4.028-1.574 1.967-2.092 4.249-2.201 6.651-.436 9.707-1.533 19.351-2.845 28.966-1.438 10.543-3.217 21.033-6.128 31.291-2.684 10.219-6.209 20.089-12.173 28.925C4.431-5.481 2.84-3.702 1.228-1.948.703-1.378-.015-.916 0 0",
    clipPath: "url(#ab)",
    style: {
      fill: "#f15f46",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 404.322 266.958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.991-.877-4.179-.569-6.217-.674-3.606-.185-7.216-.497-10.836-.568-7.957-.155-15.898-.864-23.865-.743.124 7.448-.775 14.843-1.101 22.267-.121 2.763-.619 5.505-.465 8.278a13.702 13.702 0 0 1-.56 4.687c-.111.375-.312.817-.21 1.148.832 2.691-.177 5.364-.016 8.038.121 1.993-.284 3.934-.415 5.9-.15 2.265-.301 4.53-.379 6.798-.059 1.71.013 3.416-.394 5.109-.709 2.955.029 5.962-.314 8.978-.512 4.503-.16 9.099-.569 13.62-.275 3.036-.297 6.054-.31 9.081-.016 3.63 2.244 5.046 5.642 3.713 3.88-1.522 6.759-4.353 9.4-7.365 4.934-5.629 8.813-12.007 12.056-18.727 5.026-10.413 8.818-21.29 11.791-32.465 2.03-7.625 3.743-15.321 5.007-23.098C-1.003 9.351.439 4.784 0 0",
    clipPath: "url(#ac)",
    style: {
      fill: "#f0543b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 456.797 211.176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.61-.517.383-1.224.391-1.858.025-1.984.076-3.97-.003-5.951-.263-6.539.516-13.054.414-19.588v-1.975c.365-2.371.603-4.749.394-7.151l.001-1.186c.191-4.235.595-8.462.397-12.708l.001-5.156c.051-3.312.956-6.592.396-9.929v-2.774c.532-2.227-.166-4.526.394-6.751-.293-6.931.296-13.846.485-20.764.176-6.44.354-12.893.743-19.327.413-6.837.654-13.674.751-20.519.021-1.518.641-2.974.41-4.509-1.232-1.162-2.481-2.304-3.998-3.099-.802.633-.649 1.531-.647 2.377.057 22.998.259 45.999-.086 68.992-.166 11.096-.086 22.192-.3 33.286-.17 8.776-.49 17.548-.403 26.329.026 2.637-.582 5.257-.361 7.908C-.897-2.854-.985-1.299 0 0",
    clipPath: "url(#ad)",
    style: {
      fill: "#8a97a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 250.35 508.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.541 4.223-.396 8.468-.397 12.708.085-.098.244-.194.246-.294.072-3.921.77-7.813.507-11.746C.341.438.124.222 0 0",
    clipPath: "url(#ae)",
    style: {
      fill: "#8b98a7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 252.476 575.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.087 3.318-.679 6.604-.396 9.93C.088 6.634.935 3.353 0 0",
    clipPath: "url(#af)",
    style: {
      fill: "#8b98a7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 253.005 595.987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.457 2.366-.432 4.758-.394 7.152C.484 4.809.798 2.435 0 0",
    clipPath: "url(#ag)",
    style: {
      fill: "#8b98a7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 251.945 557.349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.865 2.207-.18 4.505-.394 6.751C.464 4.543-.218 2.245 0 0",
    clipPath: "url(#ah)",
    style: {
      fill: "#8b98a7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 253.53 608.687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.03 1.94c10.739.634 21.495.689 32.246.867.572-.122 1.252.126 1.679-.491.438-.83.199-1.462-.565-1.943-.771-1.274-2.046-.625-3.102-.813-9.326.006-18.651.006-27.977.034C1.493-.404.647-.696 0 0",
    clipPath: "url(#ai)",
    style: {
      fill: "#fafcfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 184.648 868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.119-2.496-.659-4.979-.382-7.485.742-6.717.083-13.461.416-20.178.648-13.038.007-26.087.411-39.118.755-24.311.1-48.624.349-72.933.013-1.177-.011-2.354-.018-3.531l-7.192-5.956c-1.088.322-.97 1.1-.728 1.925l-.005 5.161c-.874 2.61-.658 5.273-.392 7.939l-.007 5.557c-.454.611-.559 1.312-.584 2.052-.276 8.288-.429 16.579-.798 24.865-.196 4.406.01 8.827-.106 13.24-.013.533.009 1.055.304 1.526-.001 5.424.297 10.869-.078 16.269-.455 6.542.087 13.088-.384 19.598-.578 7.996-.131 15.983-.331 23.97-.617 24.591-.539 49.187-.29 73.778.086 8.448-.074 16.916.385 25.351.248 4.557.077 9.106.32 13.649.472 8.827.584 17.662.84 26.494.204 6.98.529 13.959.795 20.939.225 5.921.464 11.846.785 17.763.27 4.994.474 9.994.784 14.984.391 6.301.781 12.603 1.197 18.903.484 7.337 1.195 14.663 1.984 21.975.471 4.367 1.29 8.695 1.929 13.043.103.702.32 1.545 1.036 1.409.831-.158.542-1.028.365-1.673-.086-.315-.183-.641-.191-.963-.089-3.39-.241-6.799-.271-10.166-.062-6.909-.012-13.839-.256-20.735-.226-6.406.117-12.826-.369-19.199-.44-5.753-.139-11.486-.313-17.224-.906-29.882-.308-59.771-.288-89.656.005-7.979-.105-15.993.371-23.96.486-8.13-.066-16.257.383-24.363C-.083 8.829-.061 4.417 0 0",
    clipPath: "url(#aj)",
    style: {
      fill: "#798798",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 250.35 508.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.188.647.375 1.295.564 1.942l.306.443c.71.122 1.419.341 2.13.352 9.943.159 19.888.289 29.832.426.263.003.528.017.791-.006 1.204-.101 2.053-.774 2.108-1.942.062-1.302-1.091-1.565-2.085-1.588-2.9-.07-5.803-.035-8.705-.04-2.505-.004-5.012-.003-7.518-.012-.518-.001-1.068.094-1.485-.348-4.663-.001-9.325-.018-13.987.012C1.245-.757.294-1.153 0 0",
    clipPath: "url(#ak)",
    style: {
      fill: "#7e90a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 229.088 867.503)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.158-.674.262-1.369.729-1.926-.088-.38-.4-.432-.712-.484C-.338-1.609-1.09-.811 0 0",
    clipPath: "url(#al)",
    style: {
      fill: "#8a97a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 240.825 705.019)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.072.058-1.608-.425-1.568-1.523.022-.594.002-1.19.002-1.785 0-57.963.02-115.927-.065-173.891-.004-2.697.593-4.445 3.246-5.232.293-.087.529-.371.79-.563-1.854-.954-3.703-.998-5.546.034-2.113.759-4.301.29-6.449.317-1.445.019-2.005.38-1.922 1.902.327 5.993.242 12.007.535 17.991.207 4.223.181 8.435.27 12.65.177 8.312.202 16.637.525 24.935.367 9.38-.025 18.752.304 28.118.839 23.914.348 47.835.253 71.749-.032 8.042.128 16.114-.362 24.144-.306 5.019.12 10.05-.386 15.022-.523 5.145.019 10.287-.463 15.412-.057.6.049 1.176.458 1.657L0 0",
    clipPath: "url(#am)",
    style: {
      fill: "#87a1b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 482.156 618.213)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.044 3.968c3.811.562 7.652.272 11.478.418 1.973-.013 3.953-.137 5.917-.007 1.987.131 1.62-1.171 1.656-2.314.038-1.164.139-2.166-1.638-2.133C11.581.035 5.79-.012 0 0",
    clipPath: "url(#an)",
    style: {
      fill: "#666779",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 294.349 868.013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 20.964.816c.605-8.442-1.542-16.083-6.676-22.847-1.642-2.166-3.633-3.99-5.975-6.06.458 2.339.241 4.309-.459 6.181C6.798-19.09 5-16.956 1.823-16.572c-2.896.35-4.789-.916-5.821-3.652-1.46-3.872-.834-7.725.477-11.425 1.317-3.721 2.134-7.542 2.116-11.412-.033-7.012-2.044-13.502-6.411-19.337-.513.614-.488 1.244-.513 1.862-.506 12.445-6.412 21.699-16.937 28.016-10.012 6.009-16.493 14.452-18.666 25.992-.47 2.498-.981 5.07-.267 7.644C-36.613.52-29.008.29-21.406.032c.528-.792.083-1.543-.141-2.272-1.547-5.035.348-8.917 4.105-12.119 1.607-1.37 3.379-2.535 5.261-3.522 1.113-.583 1.851-.514 1.674.938-.806 6.613 3.099 10.753 7.614 14.55C-1.937-1.588-1.128-.597 0 0",
    clipPath: "url(#ao)",
    style: {
      fill: "#fdba13",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 406.573 942.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a9.757 9.757 0 0 0 .406-3.117c-.284-9.572.461-19.129.488-28.7.009-3.272.25-6.574.291-9.866-.75.056-1.115.663-1.086 1.209.122 2.35-1.031 4.646-.221 7.033.223.655.285 1.502.073 2.145-1.209 3.674-.626 7.447-.733 11.177-.169 5.882-.263 11.765-.417 17.646C-1.227-1.408-1.072-.499 0 0",
    clipPath: "url(#ap)",
    style: {
      fill: "#8a97a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 238.708 624.565)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.829-2.611.211-5.295.392-7.938-1.329.279-.955 1.572-.985 2.24C-.678-3.801-1.617-1.734 0 0",
    clipPath: "url(#aq)",
    style: {
      fill: "#8a97a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 240.296 687.552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.729 4.729 0 0 0-.052-.316l-75.786.002c-.109.26-.039.458.21.593.685.358 1.43.298 2.166.32 8.324.159 16.649.027 24.972.07.529.003 1.058-.006 1.586.004 2.378.043 2.551.188 2.555 2.644.017 12.818.007 25.635.008 38.453 0 7.334.01 14.668-.007 22.001-.005 2.551-.14 2.678-2.691 2.693-8.786.05-17.573-.072-26.359.059-2.744-.095-5.487-.039-8.231-.031-.717.002-1.445.017-2.06.482.048 1.41 1.201 1.086 1.952 1.11 3.207.104 6.422.131 9.626-.002 1.302-.054 2.011.23 2.174 1.544.828.581 1.781.42 2.693.422 6.744.015 13.488.003 20.231.014.84.001 1.749-.193 2.376.629.413.882.293 1.822.294 2.74.01 7.798-.001 15.597.013 23.396.002 1.045-.151 2.128.458 3.089 1.377.295 1.099-.898 1.105-1.462.029-2.704.496-5.37.509-8.079.033-6.573.885-13.102 1.274-19.655.07-.23.115-.465.148-.702.221-1.176.259-2.361.167-3.553-.006-20.887.003-41.772.003-62.657 0-3.127.012-3.124 3.237-3.137C-26.326.63-15.223.759-4.12.606-2.724.562-1.253 1.02 0 0",
    clipPath: "url(#ar)",
    style: {
      fill: "#92a9bf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 448.35 897.185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.01-.104.022-.208.036-.312-3.041-.006-6.082-.014-9.122-.021a5.237 5.237 0 0 0-.053.329l.269.271C-5.897.748-2.924 1.169 0 0",
    clipPath: "url(#as)",
    style: {
      fill: "#849bb0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 347.185 897.19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.989-6.232 3.17-12.65 4.341-19.068 2.657-14.562 4.013-29.277 5.11-44.02.061-.808.196-1.508.673-2.21 4.192-6.175 6.204-13.196 7.806-20.37.38-11.469.115-22.941.172-34.411.042-8.576.018-17.151-.001-25.727-.004-1.376.108-2.807-1.053-3.879l-5.528-.036c-.459-.304-.912-.341-1.351.039-.37.508-.466 1.108-.431 1.699.243 4.166-.299 8.31-.404 12.465-.158 6.181-.294 12.373-.913 18.542-.732 7.291-1.148 14.61-1.859 21.905-.527 5.391-1.015 10.784-1.603 16.169-.101.919-.567 1.593-1.04 2.301-.054.301.083.555.354.601 2.291.391 2.428 2.037 2.322 3.87-.273 4.672-1.445 9.095-3.597 13.257-.419.81-1.024 1.56-.929 2.562.248 3.06-.439 6.04-.846 9.03A1128.157 1128.157 0 0 1-5.783-2.534c-.252 1.421-.779 2.8-.719 4.274 2.394.869 4.278-.42 6.215-1.478C-.178.202-.098.087 0 0",
    clipPath: "url(#at)",
    style: {
      fill: "#93b5ce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 428.734 314.872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.618.935-.244 1.861-.017 2.793.658.489 1.401.271 2.113.237 6.55-.315 13.079.371 19.622.381 1.298.002 1.936.664 2.123 1.875.985 6.402 2.265 12.755 2.975 19.207.81 7.36 1.787 14.701 2.518 22.07.582 5.85.978 11.717 1.451 17.578.228 2.815.02 5.678.751 8.452.159.2.359.346.594.444 1.496.271 2.993.533 4.398-.349 1.574-.017 3.147-.035 4.721-.051.705-.751.657-1.701.657-2.621.014-21.543.022-43.086-.005-64.629-.003-2.628-.191-2.803-2.815-2.768-1.092.015-2.069-.348-3.085-.593-3.087-.457-6.196-.116-9.296-.23-.911-.033-1.851.158-2.965-.4 1.232-.643 2.394-.293 3.476-.415 1.318-.148 1.342-.142 1.537-1.203-.724-.421-1.526-.405-2.317-.407a6295.89 6295.89 0 0 0-23.804.001C1.714-.626.762-.69 0 0",
    clipPath: "url(#au)",
    style: {
      fill: "#a5c5db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 393.292 807.718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.502.003 7.008-.082 10.506.048 1.637.06 2.069-.768 2.199-2.079.052-.523.018-1.056.018-1.585l.001-63.051c-.001-2.944-.62-3.564-3.596-3.573-2.644-.009-5.287.002-7.931.004-.298.548-.272 1.141-.265 1.738.106 8.645.226 17.297-.002 25.935C.593-29.775.575-16.99.623-4.204.629-2.729-.41-1.484 0 0",
    clipPath: "url(#av)",
    style: {
      fill: "#87a1b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 445.637 517.67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.039.055c-1.227 1.062-.997 2.517-.998 3.88-.017 16.641-.01 33.283-.01 49.924 0 3.5-.011 7 .007 10.5.005.917-.078 1.861.466 2.69 1.512.458 3.038.322 4.565.087 1.519-.011 3.047-.131 4.554-.003 1.512.129 1.99-.672 2.142-1.914.063-.522.03-1.055.03-1.583.001-20.405-.025-40.809.044-61.213C6.767.525 6.28-.186 4.354.01 2.918.156 1.453.015 0 0",
    clipPath: "url(#aw)",
    style: {
      fill: "#97b6cd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 448.35 897.185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.144-.008-.287-.017-.431-.024-.958-.817-2.125-.619-3.229-.622-8.067-.018-16.134-.007-24.201-.009-3.65-.001-3.653-.004-3.653-3.746-.002-20.498.006-40.996-.015-61.495-.002-1.219.313-2.539-.665-3.594-.814 2.457-.378 5.033-.692 7.552-.88 7.078-.931 14.226-1.283 21.348-.015.297-.232.583-.355.874-.89.927-.651 2.103-.653 3.195-.022 10.883-.011 21.767-.014 32.65-.001 1.252.057 2.512-.438 3.704-.269 1.482-1.386 1.527-2.553 1.528-5.975.004-11.949-.005-17.924.005-.787.001-1.589-.06-2.34.219-.387.144-.975.248-.618.93.876.629 1.894.497 2.872.499 6.074.017 12.148-.002 18.222.012 2.653.007 2.772.12 2.773 2.814.006 21.919.012 43.838-.009 65.756.037.379-.079.739-.149 1.105-.142.753-.108 1.505.016 2.258.15 1.25.146 2.505.146 3.761-.002 19.951-.002 39.902.001 59.853.001 1.254-.062 2.512.162 3.757.545 2.522.611 5.126.633 7.654.061 7.007 1.048 13.944 1.269 20.932.021.677-.169 1.689 1.055 1.721.712-.923.535-2.014.538-3.054.02-6.338-.003-12.676.015-19.014.008-2.53.133-2.643 2.715-2.656 7.724-.042 15.449.063 23.171-.051.474-.051.958-.064 1.397-.289.789-.908.538-1.882.173-2.866a2.01 2.01 0 0 0-.663-.309c-5.685-.332-11.374-.077-17.06-.148-2.447-.03-4.897.023-7.343-.015-2.14-.033-2.321-.243-2.385-2.438-.014-.463-.006-.926-.006-1.389V78.882c0-.265-.001-.529.001-.794.025-2.711.103-2.808 2.773-2.816 9.393-.031 18.788.038 28.183-.029.632-.118 1.327-.07 1.793-.646-.251-1.396.155-2.172 1.747-1.956.584.079 1.187.007 1.782.005.119-.259.059-.467-.177-.625-1.173-.567-2.425-.315-3.65-.358-9.513-.193-19.012.662-28.526.338-.726-.024-1.453-.019-2.179-.032-1.136-.021-1.693-.562-1.717-1.699-.014-.661-.031-1.321-.031-1.982V6.633c0-.33-.004-.661.002-.991.047-2.423.197-2.609 2.597-2.615 8.392-.022 16.784-.004 25.177-.013 1.055-.001 2.117.081 3.158-.179.248-.074.471-.197.67-.363C.611 1.63.609.805 0 0",
    clipPath: "url(#ax)",
    style: {
      fill: "#a8bbcd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 436.15 710.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.65.044c1.004 3.49.69 7.063.459 10.588-.29 4.408-.394 8.821-.634 13.228-.369 6.78-.887 13.546-1.39 20.314-.601 8.089-1.575 16.142-2.418 24.208-.069.664-.1 1.323.398 1.868l.035.072c.442.47 1.039.599 1.622.56 2.767-.186 5.609.68 8.302-.574l1.162-.032c1.466-1.781 1.223-3.9 1.218-5.988-.017-8.067-.241-16.143.048-24.2.444-12.317.255-24.63.344-36.944.008-1.057-.067-2.098-.413-3.105L0 0",
    clipPath: "url(#ay)",
    style: {
      fill: "#a5c3d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 437.79 611.37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.004.132-.005.263-.004.395 3.701.281 7.36-.611 11.058-.404 1.006.057 1.458-.496 1.591-1.378.078-.518.047-1.054.047-1.583.002-21.149.003-42.299.001-63.449 0-3.409-.03-3.437-3.386-3.445-1.653-.004-3.305.002-4.957.003-.485.521-.573 1.173-.607 1.841-.027.53-.032 1.059-.023 1.587.283 18.783-.617 37.556-.414 56.338.027 2.576-.505 5.132-.418 7.72.033.993-.407 1.624-1.469 1.749C.896-.565.371-.437 0 0",
    clipPath: "url(#az)",
    style: {
      fill: "#8eadc6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 442.499 614.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.089.739 2.323.382 3.464.331 1.593-.07 2.162.365 2.157 2.077-.059 22.605-.046 45.209-.05 67.814 1.983.002 3.976-.117 5.947.041 1.881.15 2.459-.432 2.449-2.381-.08-15.602-.045-31.205-.045-46.808 0-5.884.008-11.768-.004-17.652-.005-2.86-.176-2.83-2.989-3.095-2.964-.279-5.918-.36-8.884-.364C1.354-.519.67-.64 0 0",
    clipPath: "url(#aA)",
    style: {
      fill: "#8eadc6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 440.862 804.498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.564-.011 3.381-.022 3.601-3.559.653-10.486-.058-20.992.438-31.463.55-11.62.094-23.229.311-34.839l-1.174-.029c-1.921-.142-3.799-.696-5.745-.609-.778.034-1.563.034-2.192.605l-.025.049c-.918 1.166-.692 2.534-.534 3.816.516 4.205.463 8.44.633 12.653.671 16.637.445 33.287.47 49.934.002 1.168-.225 2.402.623 3.426L0 0",
    clipPath: "url(#aB)",
    style: {
      fill: "#a6c4da",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 442.499 614.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.505 1.735.414 3.516.414 5.292-.002 18.615-.001 37.23 0 55.845 0 .984-.126 1.991.468 2.88 1.37-4.479 2.122-9.09 2.9-13.692C6.49 34.32 8.213 18.203 9.222 2.006 8.333.156 6.818-.232 4.899-.044 3.28.114 1.634-.004 0 0",
    clipPath: "url(#aC)",
    style: {
      fill: "#87a1b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 451.465 514.452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.546-.034c1.731-.08 3.474-.016 5.183-.391-.066-4.007-.066-4.007-4.112-4.01-4.222-.002-8.45.101-12.667-.051-1.977-.072-2.604.612-2.328 2.465.096.646.021 1.318.024 1.977L0 0",
    clipPath: "url(#aD)",
    style: {
      fill: "#666779",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 477.969 862.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.044-.037c-.388-1.518.033-2.262 1.75-1.983.595.096 1.301.209 1.813-.36l-4.395-.028c-2.644-.979-5.286-.998-7.927.01-1.48.791-3.078.181-4.606.385-.641.086-1.628-.347-1.688.78-.066 1.244.919 1.216 1.797 1.217L0 0",
    clipPath: "url(#aE)",
    style: {
      fill: "#92a9bf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 440.862 804.498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-9.924.014c-.525.78-.512 1.558.008 2.334 2.894 1.055 5.792.994 8.695.041l1.226-.043L0 0",
    clipPath: "url(#aF)",
    style: {
      fill: "#87a1b7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 444.087 517.627)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.937.004c-.445-.543-1.08-.292-1.63-.402C5.246-.61 4.238-.909 4.383-2.333l-4.384-.024L0 0",
    clipPath: "url(#aG)",
    style: {
      fill: "#8eadc6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 436.151 707.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .466-.04C.928-.619.774-1.287.75-1.942c-.11-3.034-.253-6.067.21-9.09.15-.983.047-1.972-.032-2.962C.486-19.581.177-25.175-.153-30.769c-.425-7.172-.722-14.352-1.044-21.528-.218-4.871-.634-9.744-.535-14.63.021-1.046.144-2.121-.37-3.111-.088-.091-.179-.18-.269-.27-1.587.012-3.174-.005-4.759.042-1.494.045-2.286.861-2.36 2.356-.016.329-.003.661-.003.991v63.855c0 3 .034 3.029 2.949 3.041C-4.363-.014-2.182-.007 0 0",
    clipPath: "url(#aH)",
    style: {
      fill: "#859db1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 338.702 517.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.599-.619 1.372-.369 2.069-.371 6.746-.023 13.492-.044 20.237-.005 1.517.009 2.153-.421 1.489-1.959-.592-.674-1.41-.664-2.191-.664C13.382-3 5.159-3.092-3.063-2.962c-4.013-.09-8.027-.029-12.041-.031-.722 0-1.453 0-2.113.376-.092.091-.182.182-.273.275.336 1.861-.475 2.579-2.3 2.363-.586-.07-1.191.035-1.782-.012-1.306-.104-1.783.611-1.831 1.774-.022.528-.01 1.057-.01 1.586 0 21.153.021 42.308-.035 63.461-.005 2.007.16 3.332 2.673 3.156.855-.059 1.803.39 2.724.273 1.604-.203 1.976.603 1.76 1.976l.05.052c.828.725 1.848.592 2.822.606 4.932.068 9.864-.154 14.795-.054 1.722.012 3.45.17 5.159-.197.881-.676 2.539-.913 1.53-2.672-3.841-.546-7.706-.116-11.557-.26-3.657-.117-7.324.286-10.971-.24a5.131 5.131 0 0 0-.704-.183c-1.097-.424-.819-1.428-.836-2.213-.1-4.618-.281-9.241-.339-13.851-.21-16.572-.753-33.142-.486-49.717.041-2.55.053-2.58 2.147-2.91 4.176.08 8.352.083 12.528-.008C-1.374.617-.602.621 0 0",
    clipPath: "url(#aI)",
    style: {
      fill: "#859cb0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 357.261 707.679)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.303-1.502-.051-2.122-1.83-2.021-3.328.191-6.675.062-10.015.033-.69-.006-1.457.248-2.044-.375-.973-1.158-.966-2.545-.94-3.943.376-19.895.478-39.792.388-59.69-.006-1.166.242-2.403-.604-3.432l-.06-.061c-1.915.012-3.829.055-5.743.03-1.173-.016-1.609.438-1.179 1.565.317.835.197 1.698.197 2.548.008 20.067.006 40.133.006 60.2.001 2.76.004 2.759 2.704 2.779.528.003 1.058-.014 1.584.019 1.464.093 2.387.678 2.054 2.351.089.085.18.171.269.258 2.432.652 4.924.103 7.377.365 1.884.034 3.77.043 5.653-.009C-1.421.596-.601.65 0 0",
    clipPath: "url(#aJ)",
    style: {
      fill: "#849bb0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 355.141 804.542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.636.107-3.268-.09-4.917.321-1.211.303-1.628.996-1.791 2.028-.082.516-.029 1.054-.029 1.583V67.54c0 2.717.004 2.715 2.754 2.731 1.189.005 2.377.02 3.566.032l.07-.067c.844-1.028.597-2.263.598-3.426.018-15.184-.048-30.368.041-45.551.035-5.934.537-11.863.366-17.805C.632 2.533.729 1.603.448.701A2.45 2.45 0 0 0 .032.028Z",
    clipPath: "url(#aK)",
    style: {
      fill: "#839baf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 334.498 804.538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 8.737.012A4.418 4.418 0 0 1 8.75-.37C5.836-.169 2.886-.851 0 0",
    clipPath: "url(#aL)",
    style: {
      fill: "#93aabc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 259.35 889.23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.525 1.073 5.143.524 7.651.978 2.077.376 2.827-.568 2.839-2.679.004-.595.001-1.191.001-1.786-.001-2.917-.094-3.037-2.531-1.49C5.517-3.425 3.2-1.679.485-.591.287-.512.174-.22 0 0",
    clipPath: "url(#aM)",
    style: {
      fill: "#8d9bab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 271.3 970.015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.957.015 3.969.003 3.97-3.916 0-1.377-.104-2.764.025-4.129.178-1.893-.651-2.523-2.407-2.262.431 2.068.318 4.169.433 6.259C2.119-2.233 1.702-.838 0 0",
    clipPath: "url(#aN)",
    style: {
      fill: "#8dacc4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 291.64 889.748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.54-1.187-1.574-1.913-2.525-2.718-1.765-1.494-3.448-3.073-4.928-4.854-2.451-2.951-2.796-6.456-2.547-10.082.115-1.668-.441-1.749-1.758-1.035-2.618 1.419-5.163 2.934-7.257 5.083-3.313 3.398-4.506 7.332-2.897 11.938.195.558.338 1.133.506 1.7z",
    clipPath: "url(#aO)",
    style: {
      fill: "#f8f294",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 406.573 942.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.246.951-.513 1.897-.733 2.854-.212.922-.046 1.602 1.132 1.485C.22 2.896.879 1.378 0 0",
    clipPath: "url(#aP)",
    style: {
      fill: "#a8cae1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 293.21 868.032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.362 1.913c-.649-.315-1.293-.123-1.921.049-5.075 1.392-10.214 2.422-15.479 2.748-1.746.534-3.475.183-5.206-.101-6.313-.037-12.366-1.513-18.369-3.283-.731-.215-1.459-.692-2.267-.229-1.374-.085-2.552-.834-3.862-1.135 2.903 10.984 6.682 21.589 13.652 30.754 3.159 4.154 6.959 7.587 11.858 9.653.85.358 1.558.366 2.431.025 2.687-1.05 4.922-2.793 7.215-4.458C-9.586 27.594-5.16 16.869-1.58 5.688-.98 3.817-.215 1.982 0 0",
    clipPath: "url(#aQ)",
    style: {
      fill: "#666678",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 428.734 314.872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.631 1.119-.85 2.314-.847 3.602.023 11.69-.223 23.387.099 35.068C-.54 46.2-.25 53.746.555 61.273c.348 3.251.547 6.619.569 9.939.006 1.066.297 1.728 1.239 2.135.086.904.786 1.333 1.42 1.799 6.006 4.425 12.795 6.762 20.161 7.583 1.774.198 3.539.463 5.329.341.786-.054 1.621-.032 2.035-.928.335-.962.266-1.96.264-2.948-.028-22.717.106-45.435-.091-68.152-.026-3.031-.122-6.066-.175-9.1-.013-.778.023-1.6-.63-2.21-1.669-.619-3.403-.261-5.106-.31-2.708-.077-5.42.036-8.129-.062-5.248.059-10.503-.304-15.745.215C1.109-.368.514-.346 0 0",
    clipPath: "url(#aR)",
    style: {
      fill: "#b1d7f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 348.857 514.432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c6.688 2.29 13.481 4.041 20.62 4.021.582-.638.633-1.435.634-2.23.016-13.729.039-27.458-.011-41.187a4.895 4.895 0 0 0-.144-1.171c-.338-1.174-1.358-1.359-2.332-1.484-9.989-1.287-17.736-6.227-23.541-14.363-.337-.471-.626-1.033-1.328-1.062-.98.231-.707 1.046-.64 1.619.727 6.174 1.513 12.341 2.26 18.513.575 4.745 1.011 9.51 1.712 14.236.546 3.687.782 7.404 1.309 11.096.495 3.463.456 7.017 1.046 10.493C-.328-1.004-.141-.506 0 0",
    clipPath: "url(#aS)",
    style: {
      fill: "#b1d6ee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 362.595 313.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c6.245 9.785 15.243 15.048 26.705 16.27.643.528 1.408.528 2.178.512 9.353.02 17.378-3.402 24.11-9.734 2.098-1.973 4.356-4.052 5.04-7.126 2.971-5.151 4.776-10.643 4.844-16.638.032-2.733-.445-3.193-3.206-3.162-.9-.254-1.487.395-2.151.776-7.212 4.138-14.948 6.621-23.225 7.452-1.776.178-3.54.426-5.332.347-.801-.033-1.592-.021-2.263.513-10.549.178-20.233-2.34-28.539-9.154-2.739.145-3.42 1.236-3.107 4.412C-4.399-9.991-2.841-4.798 0 0",
    clipPath: "url(#aT)",
    style: {
      fill: "#656779",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 354.46 390.043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2.424c.863-1.021.62-2.259.619-3.423-.009-16.651.076-33.302-.053-49.952-.018-1.276.346-2.616-.616-3.737-.103-.165-.299-.333-.294-.494.134-4.14-.631-8.215-.859-12.328-.308-5.555-.549-11.114-.838-16.67-.012-.232-.222-.453-.34-.678-.765 1.495-2.045 1.767-3.616 1.757-7.855-.051-15.71-.035-23.565-.012-1.032.003-2.136-.199-3.011.624.157.746 1.101.602 1.438 1.255-.81.597-1.926.399-2.645 1.099l.453.057 17.432-.05A95.48 95.48 0 0 1-.38-82.557c.573.443.402 1.08.402 1.653C.02-53.936.009-26.968 0 0",
    clipPath: "url(#aU)",
    style: {
      fill: "#91a9bf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 390.06 404.43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c9.279 0 18.56-.058 27.837.047 1.933.022 2.644-.56 2.356-2.417-.007-21.815-.01-43.63-.037-65.444-.002-.818.336-1.73-.385-2.451-.693-.631-1.56-.632-2.413-.636-4.068-.022-8.136-.011-12.204-.009-.999.001-1.957.166-2.848.64l-5.156.012c-2.087.426-4.198.108-6.296.191-2.061.082-2.827.774-3.037 2.845-.034.328-.04.658-.04.988-.008 20.795-.016 41.589.006 62.384.002 1.556.119 3.082 1.831 3.834.129-.002.258.003.386.016",
    clipPath: "url(#aV)",
    style: {
      fill: "#b1d7f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 349.86 517.647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.966-1.101-1.228-2.373-1.225-3.835.035-20.804.024-41.608.024-62.412 0-3.171.441-3.533 3.7-3.63 1.678-.051 3.412.449 5.037-.365l-17.841.021c-.281 8.915.656 17.793.842 26.697.106 5.124.528 10.253.753 15.384.212 4.856.754 9.697 1.114 14.547.21 2.838-.602 5.632-.38 8.487.133 1.703-.064 3.432.458 5.101L0 0",
    clipPath: "url(#aW)",
    style: {
      fill: "#92b2cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 349.346 517.668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.548.192-1.169.278-1.628.599-.789.549-2.04.379-2.447 1.398-.185.462.465.515.834.492 1.487-.088 3.275 1.205 4.329-.919.218-.439.237-.893-.013-1.311C.814-.177.408-.036 0 0",
    clipPath: "url(#aX)",
    style: {
      fill: "#8d9bab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 538.727 973.002)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.927-.01c.002-21.247.008-42.493.001-63.739-.001-1.124.026-2.233.365-3.314-11.776-.012-23.552-.006-35.327-.062-1.37-.006-1.995.217-1.991 1.816.06 21.764.052 43.529.062 65.292L0 0",
    clipPath: "url(#aY)",
    style: {
      fill: "#b1d7ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 431.909 807.696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .028 66.766c.001 2.718.001 2.72 2.811 2.718l28.926-.018c.147-5.935-.716-11.805-1.086-17.706-.301-4.79-.839-9.551-1.297-14.322-.45-4.701-1.133-9.378-1.635-14.075-.564-5.285-1.387-10.529-2.31-15.759-.387-2.196-.828-4.383-1.143-6.588-.159-1.114-.746-1.417-1.746-1.406-6.733.075-13.45-.658-20.186-.363C1.582-.719.81-.508.034-.38.024-.253.013-.126 0 0",
    clipPath: "url(#aZ)",
    style: {
      fill: "#c0def1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 393.224 803.487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c9.251.011 18.502-.007 27.752.06 1.497.01 2.056-.324 2.051-1.962a12341.97 12341.97 0 0 1-.001-63.236c.004-1.602-.489-1.997-2.023-1.985-9.382.075-18.765.057-28.149.069-.388.438-.347.973-.343 1.501.13 20.845.015 41.691.063 62.536C-.647-1.974-.781-.883 0 0",
    clipPath: "url(#ba)",
    style: {
      fill: "#b0d5ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 350.4 807.709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 26.949.057c1.291-.311.803-1.366.806-2.12.035-12.541.034-25.084.04-37.626l-.029-30.145c-.546-.355-1.159-.197-1.741-.198-7.936-.011-15.871-.009-23.806-.006-2.291.001-2.718.416-2.861 2.742-.036.594-.025 1.19-.025 1.785-.001 20.632-.005 41.265.01 61.897C-.656-2.384-.92-1.076 0 0",
    clipPath: "url(#bb)",
    style: {
      fill: "#b1d6ee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 353.057 710.867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.005-22.412-.012-44.825-.011-67.237 0-2.422.189-2.599 2.588-2.6 8.397-.003 16.793.001 25.189.002-.569-.684-1.351-.397-2.04-.399-8.054-.023-16.108-.019-24.163-.022l-7.923.023c-1.796.424-3.62.073-5.427.2-.699.05-1.432-.207-2.095.208.07 12.424-.606 24.837-.445 37.263.141 10.847.049 21.698.06 32.546L0 0",
    clipPath: "url(#bc)",
    style: {
      fill: "#a0bcd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 353.057 710.867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.002-21.247-.007-42.494 0-63.741.001-1.124-.021-2.234-.37-3.313l-2.041-.057-9.079.057c-.012 14.524.189 29.052-.129 43.568-.158 7.248-.171 14.494-.312 21.74-.024 1.195.198 1.957 1.598 1.758z",
    clipPath: "url(#bd)",
    style: {
      fill: "#9eb9ce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 350.4 807.709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .002 53.55c11.004-.268 21.275-3.001 30.547-9.089 1.287-.409 1.537-1.281 1.639-2.606.361-4.704.988-9.388 1.451-14.085.342-3.463.582-6.937.872-10.405.508-6.083 1.212-12.158 1.449-18.251.122-3.125.598-6.221.324-9.427-.239-2.783-.056-5.751.304-8.576.431-3.372.176-6.716.291-10.07L28.183-29l-1.214.045c-.738.688-.807 1.614-.939 2.536-1.629 11.373-3.429 22.71-7.122 33.647-.868 2.572-1.978 5.036-3.25 7.43-.654 1.229-1.432 2.383-2.389 3.392-2.582 2.724-5.047 2.564-7.246-.486-1.979-2.745-2.678-6.004-3.516-9.189-.554-2.106-.77-4.288-1.243-6.414C1.091 1.184 1.132.191 0 0",
    clipPath: "url(#be)",
    style: {
      fill: "#b0d6ee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 393.288 475.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.641 7.341-11.048 12.388-19.383 14.933-3.103.948-6.295 1.317-9.525 1.425-.769.809-.665 1.835-.666 2.816-.015 13.163-.02 26.326-.001 39.489.004 3.161.256 3.345 3.467 2.955 5.979-.156 11.752-1.422 17.419-3.249 1.437-3.704 1.639-7.667 2.355-11.517 1.136-6.108 2.104-12.25 3.05-18.392.907-5.883 1.7-11.784 2.539-17.678.378-2.654.788-5.304 1.098-7.967C.462 1.879.806.849 0 0",
    clipPath: "url(#bf)",
    style: {
      fill: "#b1d7f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 431.837 390.147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.004-13.349.199-26.7-.062-40.043a865.468 865.468 0 0 0-.79-23.887c-.091-1.959-.293-3.928-.34-5.9-10.117-.01-20.232.001-30.348-.056-1.361-.008-1.823.375-1.82 1.784.038 22.149.038 44.297.001 66.446-.002 1.552.509 2.089 2.065 2.074C-24.948.354-18.588.63-12.258.303-8.167.091-4.084.136 0 0",
    clipPath: "url(#bg)",
    style: {
      fill: "#c1def1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 437.707 614.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.657-5.736 1.353-11.468 1.956-17.209.357-3.397.605-6.807.843-10.215.545-7.803 1.263-15.6 1.511-23.414.184-5.865.724-11.725.523-17.607-.035-1.035-.622-1.327-1.248-1.762-9.924-.004-19.848.025-29.771-.046-1.578-.012-2.009.454-2.006 2.016.046 22.096.04 44.193.011 66.289-.002 1.328.144 2.042 1.785 2.026C-17.598-.013-8.799.014 0 0",
    clipPath: "url(#bh)",
    style: {
      fill: "#c1def1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 430.809 517.703)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.976.012c-1.228.556-1.7 1.585-1.79 2.858-.055.792-.052 1.585-.052 2.378-.001 20.286-.002 40.572.001 60.858 0 3.963.007 3.998 4.006 3.957 7.125-.074 14.235.651 21.363.382 1.056-.04 2.126.063 3.068-.566 0-22.521-.017-45.04.037-67.561.004-1.756-.375-2.378-2.27-2.349C14.926.079 7.462.006 0 0",
    clipPath: "url(#bi)",
    style: {
      fill: "#b1d6ee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 357.261 707.679)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.338 2.698 1.159 5.746 1.97 8.564.925 3.217 1.619 6.521 3.588 9.339 2.448 3.507 5.774 3.565 8.415.188 3.914-5.008 5.735-10.938 7.355-16.916 2.508-9.253 4.131-18.686 5.269-28.203.077-.648.246-1.285.372-1.928-8.375-.009-16.751.016-25.125-.059-1.49-.013-1.905.443-1.894 1.911.056 7.847.012 15.694.003 23.542L0 0",
    clipPath: "url(#bj)",
    style: {
      fill: "#c1dff3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 393.288 475.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-8.595-.004-17.189-.04-25.783.019-1.519.01-2.044-.361-2.04-1.98.053-21.552.046-43.104.011-64.656-.002-1.3.52-2.277 1.217-3.25-4.233.008-8.466.015-12.698.024-1.276 1.031-1.042 2.491-1.044 3.852-.019 12.342-.011 24.684-.011 37.027 0 8.581-.007 17.161.008 25.741.003 1.106-.173 2.268.64 3.221l.399.005c2.926.414 5.868.069 8.8.195.772.033 1.571-.197 2.314.191l11.885.022c.617.64 1.436.607 2.217.613 3.819.034 7.638.03 11.458.004.793-.006 1.589-.045 2.224-.631L0 0",
    clipPath: "url(#bk)",
    style: {
      fill: "#a0bdd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 390.087 614.507)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-15.898.013c-.166.938-1.173 1.206-1.563 1.965l17.465.004L0 0",
    clipPath: "url(#bl)",
    style: {
      fill: "#92b2cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 389.55 613.977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.001-22.243.006-44.487-.007-66.731-.001-1.067.084-2.099.413-3.111-2.785-.047-2.787-.047-2.786 2.723 0 9.322-.211 18.651.067 27.966.234 7.788.042 15.585.431 23.355.238 4.753.182 9.494.274 14.239C-1.584-.352-1.21.173 0 0",
    clipPath: "url(#bm)",
    style: {
      fill: "#92b2cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 337.154 614.51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.209-.773-2.55-.322-3.824-.364-2.427-.081-4.86-.023-7.29-.022 1.343.808 2.814.304 4.22.364C-4.6.073-2.298.001 0 0",
    clipPath: "url(#bn)",
    style: {
      fill: "#92b2cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 352.505 613.989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.501-.243 5.053.429 7.522-.408l-7.527.009L0 0",
    clipPath: "url(#bo)",
    style: {
      fill: "#92a9bf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 334.547 803.968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.829-.152-2.831-.152-2.829-3.121L-2.8-45.26l-2.421-.011.017 45.227C-3.472.34-1.74.635 0 0",
    clipPath: "url(#bp)",
    style: {
      fill: "#91a9bf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 397.027 307.99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.796-.693-1.753-.34-2.631-.354-2.871-.048-5.744-.029-8.615-.009-.628.005-1.322-.207-1.845.368L0 0",
    clipPath: "url(#bq)",
    style: {
      fill: "#92b2cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 389.553 514.505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c4.349 3.604 9.433 5.645 14.958 6.205 12.527 1.27 22.689-3.148 30.11-13.426 3.576-4.95 5.242-10.613 5.669-16.666.063-.887-.01-1.516-1.144-.799-5.598 3.54-11.803 5.565-18.156 7.212-.69.682-.62 1.571-.625 2.422-.014 2.067-.37 4.084-.908 6.065-.634 2.341-1.155 2.73-3.65 2.739-6.415.025-12.83.005-19.245.011-.859 0-1.724-.038-2.567.168-1.033.253-1.915.806-2.035 1.912-.162 1.498-.717 2.62-2.124 3.28C-.011-.739-.097-.355 0 0",
    clipPath: "url(#br)",
    style: {
      fill: "#92d6e4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 367.798 379.927)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.107-.165.194-.455.325-.476 2.059-.337 2.636-1.53 2.582-3.561-.04-1.544 1.478-1.591 2.685-1.593 7.055-.011 14.113-.092 21.166.047 2.157.041 3.092-.815 3.627-2.735.837-3.007 1.133-6.054 1.052-9.156-4.044.583-8.065 1.383-12.169 1.454-11.409.199-22.23-1.719-31.582-8.92C-13.555-18.65-8.732-5.792 0 0",
    clipPath: "url(#bs)",
    style: {
      fill: "#46c4e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 367.798 379.927)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.49b71ea3cb103cea581b2d1768586efe.svg";
export { ForwardRef as ReactComponent };